
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9EfFC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dOMrE = parcelRequire("dOMrE");


var $i0btU = parcelRequire("i0btU");

/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $6mYMS = parcelRequire("6mYMS");




const $1278ab3a4b348f22$var$mentionStyle = {
    [(0, $6mYMS.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $6fnsQ.B400)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $6fnsQ.N20)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $6fnsQ.B400)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $6fnsQ.B400)})`
    },
    [(0, $6mYMS.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $6fnsQ.N500)})`,
        text: `var(--ds-text, ${(0, $6fnsQ.N500)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $6mYMS.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N30A)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $6fnsQ.N30A)})`
    }
};
const $1278ab3a4b348f22$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $1278ab3a4b348f22$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $1278ab3a4b348f22$var$PrimitiveMention = /*#__PURE__*/ (0, $42omo.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $1278ab3a4b348f22$export$2e2bcd8739ae039 = $1278ab3a4b348f22$var$PrimitiveMention;



var $l2474 = parcelRequire("l2474");





var $3jsXx = parcelRequire("3jsXx");


var $1DWH0 = parcelRequire("1DWH0");


var $28cxD = parcelRequire("28cxD");


var $bwC67 = parcelRequire("bwC67");





var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $af19f55bb4052571$export$1d011e4240507c78 = new (0, $9801n.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
class $af19f55bb4052571$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        $af19f55bb4052571$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}


const $893da78086ca16ac$export$7452d7062a4d0634 = 1000;
const $893da78086ca16ac$export$af8124aa496797f2 = '_|unknown|_';
class $893da78086ca16ac$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        (0, $af19f55bb4052571$export$1d011e4240507c78).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $af19f55bb4052571$export$1d011e4240507c78).getInstance(this.props.id);
        if ([
            (0, $28cxD.UFOExperienceState)['STARTED'],
            (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC67.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$893da78086ca16ac$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $6mYMS.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dOMrE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1278ab3a4b348f22$export$2e2bcd8739ae039), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showTooltip
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af19f55bb4052571$export$5ef1c2550074a375), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i0btU.default), null, showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: mentionComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l2474.default), {
            name: text
        }, mentionComponent)) : mentionComponent)));
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $893da78086ca16ac$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $6mYMS.MentionType).SELF;
            if ((0, $6mYMS.isRestricted)(accessLevel)) return (0, $6mYMS.MentionType).RESTRICTED;
            return (0, $6mYMS.MentionType).DEFAULT;
        };
        (0, $af19f55bb4052571$export$1d011e4240507c78).getInstance(props.id).start();
    }
}
const $893da78086ca16ac$var$MentionWithAnalytics = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($893da78086ca16ac$export$92ab8442e7a15cef);
const $893da78086ca16ac$var$Mention = $893da78086ca16ac$var$MentionWithAnalytics;
var $893da78086ca16ac$export$2e2bcd8739ae039 = $893da78086ca16ac$var$Mention;
module.exports["UNKNOWN_USER_ID"] = $893da78086ca16ac$export$af8124aa496797f2;
module.exports["default"] = $893da78086ca16ac$export$2e2bcd8739ae039;

});

parcelRegister("jMZdB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $d8ohW = parcelRequire("d8ohW");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $cOQz3 = parcelRequire("cOQz3");


var $1s5hv = parcelRequire("1s5hv");

const $ea5bd56cfe7af0a8$var$styles = {
    agentChatIcon: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsbzwfg _4t3izwfg"
};
const $ea5bd56cfe7af0a8$export$f33bbc5f5534c8a4 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $ea5bd56cfe7af0a8$var$styles.agentChatIcon,
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
            label: "",
            color: "var(--ds-icon-subtlest, #6B6E76)"
        })
    });
};



var $lBFuf = parcelRequire("lBFuf");


var $cgtv4 = parcelRequire("cgtv4");

const $e1133cfae3bfd440$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStateSuggestion1: {
        id: "ai-mate.chat-history.empty-state.suggestion1",
        defaultMessage: "Are any of my tickets overdue?"
    },
    emptyStateSuggestion2: {
        id: "ai-mate.chat-history.empty-state.suggestion2",
        defaultMessage: "What should I work on next?"
    },
    emptyStateSuggestion3: {
        id: "ai-mate.chat-history.empty-state.suggestion3",
        defaultMessage: "Write an update about my week"
    },
    agentEmptyStateSuggestion1: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion1",
        defaultMessage: "Tell me about yourself"
    },
    agentEmptyStateSuggestion2: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion2",
        defaultMessage: "What can you help me with?"
    },
    agentEmptyStateSuggestion3: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion3",
        defaultMessage: "Summarize what I'm looking at"
    }
});


const $1694d7942d86318a$var$styles = {
    conversationStartersList: "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
    conversationStartersListRefresh: "_1bsb1osq",
    conversationStarterIcon: "_1o9zidpf",
    conversationStarterText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1o9zkb7n _1ul9idpf",
    button: "_11c8fhey _2rko12b0 _syazazsu _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _1bsb1osq _bfhksm61 _irr31dpa _1di6fcek"
};
const $1694d7942d86318a$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const type = 'static';
    const customAgentConversationStarters = [
        {
            message: (0, $e1133cfae3bfd440$export$defe85febe8b728c).agentEmptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $e1133cfae3bfd440$export$defe85febe8b728c).agentEmptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $e1133cfae3bfd440$export$defe85febe8b728c).agentEmptyStateSuggestion3,
            type: type
        }
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        {
            message: (0, $e1133cfae3bfd440$export$defe85febe8b728c).emptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $e1133cfae3bfd440$export$defe85febe8b728c).emptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $e1133cfae3bfd440$export$defe85febe8b728c).emptyStateSuggestion3,
            type: type
        }
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return user defined suggestions + static fallback suggestions with a max of 3 suggestions (user defined taking precendence over fallback)
        return [
            ...userDefinedConversationStarters,
            ...customAgentConversationStarters
        ].slice(0, 3);
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $1694d7942d86318a$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $42omo.useMemo)(()=>$1694d7942d86318a$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $42omo.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                message: starter.message,
                type: starter.type
            } : {
                message: formatMessage(starter.message),
                type: starter.type
            }), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1694d7942d86318a$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $1694d7942d86318a$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        as: "ul",
        space: "space.050",
        xcss: (0, $1Whri.cx)($1694d7942d86318a$var$styles.conversationStartersList, (0, $dh538.fg)('rovo_agent_empty_state_refresh') && $1694d7942d86318a$var$styles.conversationStartersListRefresh),
        children: [
            starters.map((starter, index)=>{
                const isLastStarter = index === starters.length - 1;
                const chatPill = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "li",
                    children: (0, $dh538.fg)('rovo_agent_empty_state_refresh') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        xcss: $1694d7942d86318a$var$styles.button,
                        onClick: ()=>onConversationStarterClick(starter),
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.150",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $1694d7942d86318a$var$styles.conversationStarterIcon,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ea5bd56cfe7af0a8$export$f33bbc5f5534c8a4), {})
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $1694d7942d86318a$var$styles.conversationStarterText,
                                    children: starter.message
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
                        testId: "conversation-starter",
                        onClick: ()=>onConversationStarterClick(starter),
                        children: starter.message
                    }, starter.message)
                }, starter.message);
                return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    grow: "fill",
                    alignInline: "end",
                    children: [
                        chatPill,
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
                            onClick: onReloadButtonClick,
                            appearance: "subtle",
                            label: ""
                        })
                    ]
                }, starter.message) : chatPill;
            }),
            !!onBrowseAgentsClick && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "li",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.BrowseAgentsPill), {
                    onClick: onBrowseAgentsClick
                })
            })
        ]
    });
};
module.exports["getConversationStarters"] = $1694d7942d86318a$export$c2d882153e0984c5;
module.exports["AgentConversationStarters"] = $1694d7942d86318a$export$171adfc74aa509c3;

});

parcelRegister("16lEl", function(module, exports) {
const $99e3e594de94f1bc$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList'
};
var $99e3e594de94f1bc$export$3615d040a39afa1e = /*#__PURE__*/ function(ExperienceNamePostfix) {
    ExperienceNamePostfix["MINI_MODAL"] = "miniModal";
    return ExperienceNamePostfix;
}({});
const $99e3e594de94f1bc$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $99e3e594de94f1bc$export$233a4307e330ea30 = [
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION
];
const $99e3e594de94f1bc$export$449b821dadec8760 = [
    // Experiences with timeouts must be listed first:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    // Experiences without timeouts:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$99e3e594de94f1bc$export$233a4307e330ea30
];
module.exports["ExperienceName"] = $99e3e594de94f1bc$export$b881bd9f00ed8ed1;
module.exports["ExperienceNamePostfix"] = $99e3e594de94f1bc$export$3615d040a39afa1e;
module.exports["sendMessageExperienceName"] = $99e3e594de94f1bc$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $99e3e594de94f1bc$export$233a4307e330ea30;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $99e3e594de94f1bc$export$449b821dadec8760;

});

parcelRegister("kIvLT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6v6KC = parcelRequire("6v6KC");

var $inPa6 = parcelRequire("inPa6");


var $fYQcF = parcelRequire("fYQcF");


var $1yaYZ = parcelRequire("1yaYZ");


var $TwPkE = parcelRequire("TwPkE");


var $jA9SA = parcelRequire("jA9SA");


var $bQGO7 = parcelRequire("bQGO7");


var $ffCOo = parcelRequire("ffCOo");

const $79e4722581e5fb43$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent'
];


const $ee6ebd3561b1c806$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $79e4722581e5fb43$export$e31e24b63b7085fd).includes(x.source);
};
const $ee6ebd3561b1c806$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$ee6ebd3561b1c806$var$isSourceAndAttributes(x) || x[0, $ffCOo.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $ffCOo.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};


const $6e0837af2bd4bfd5$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $6e0837af2bd4bfd5$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $6e0837af2bd4bfd5$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $TwPkE.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $42omo.useCallback)((inputPayload)=>{
        const payload = (0, $6v6KC.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $6e0837af2bd4bfd5$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
    ];
    if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            const aiMateContextAttributes = (0, $ee6ebd3561b1c806$export$d97c97ed77ff09e8)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $42omo.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, mode: mode, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias } = propertiesRef.current;
        return {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).mode]: mode,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $42omo.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
        ];
        if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, scenarioId: scenarioId, pageContext: pageContext, attributes: customAttributes } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributes
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (responseSources) attributes.responseSources = responseSources;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        if (assistanceServiceConfigMinionAlias) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        let libAttributes = {
            ...attributes,
            aiFeatureName: 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0
        };
        switch(payload.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                trackAIResultAction(payload.actionResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'feedback':
                trackAIFeedbackSubmit(payload.feedbackResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $42omo.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $6e0837af2bd4bfd5$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        let eventToBeLoggedWithSentry;
        if ((0, $6v6KC.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $ee6ebd3561b1c806$export$d97c97ed77ff09e8)(payload.context);
            const updatedEvent = payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            });
            updatedEvent.fire((0, $bQGO7.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $ee6ebd3561b1c806$export$d97c97ed77ff09e8)(event.context);
            const updatedEvent = event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            });
            updatedEvent.fire((0, $bQGO7.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $1yaYZ.addSentryBreadcrumb)(`sendAnalyticsEvent event: ${JSON.stringify(eventToBeLoggedWithSentry)}`);
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["useAnalytics"] = $6e0837af2bd4bfd5$export$e955abb82869dc84;

});

parcelRegister("1yaYZ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8Igpw = parcelRequire("8Igpw");


var $j2DyP = parcelRequire("j2DyP");

const $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};


const $62424571d4d73005$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $62424571d4d73005$var$ATLAS_HOST = 'home.atlassian.com';
const $62424571d4d73005$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $62424571d4d73005$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $62424571d4d73005$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $62424571d4d73005$var$ATLAS_HOST || parsedUrl.host === $62424571d4d73005$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$62424571d4d73005$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $62424571d4d73005$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($62424571d4d73005$var$UUID_REGEX) || [];
    const normalized = str.replace($62424571d4d73005$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};



// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $26a7abafe1ae99d6$var$importSentryAsync = async ()=>(parcelRequire("6jYyB"));
let $26a7abafe1ae99d6$var$sentryClient;
let $26a7abafe1ae99d6$var$accountIdPromise;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $26a7abafe1ae99d6$var$getEnvironment = ()=>{
    return 'production';
};
const $26a7abafe1ae99d6$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc)();
    try {
        if ((0, $dh538.fg)('rovo_chat_enable_additional_breadcrumbs')) {
            if (!$26a7abafe1ae99d6$var$accountIdPromise) $26a7abafe1ae99d6$var$accountIdPromise = new Promise((resolve, reject)=>{
                (0, $8Igpw.performHttpFetch)({
                    path: '/gateway/api/me',
                    options: {
                        method: 'GET'
                    }
                }).then((profileData)=>{
                    if (profileData?.account_id) resolve(profileData.account_id);
                    else reject(new Error('Profile data not loaded'));
                }).catch((error)=>{
                    reject(error);
                });
            });
            accountId = await $26a7abafe1ae99d6$var$accountIdPromise;
        } else {
            const profileData = await (0, $8Igpw.performHttpFetch)({
                path: '/gateway/api/me',
                options: {
                    method: 'GET'
                }
            });
            if (profileData?.account_id) accountId = profileData.account_id;
        }
    } catch  {
    // do nothing
    }
    if ($26a7abafe1ae99d6$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $26a7abafe1ae99d6$var$sentryClient.setTag('product', product);
        $26a7abafe1ae99d6$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $26a7abafe1ae99d6$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    importedSentry.init({
        dsn: customSentryDsn || defaultSentryDsn,
        environment: $26a7abafe1ae99d6$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName || '@atlassian/conversation-assistant',
                product: product,
                packageVersion: packageVersion
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $j2DyP.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                updatedEvent.request.url = (0, $62424571d4d73005$export$d57ae76c6dc57a5)(updatedEvent.request.url);
            }
            if (updatedEvent.exception?.values) {
                const allMatchedUUIDs = [];
                updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                    const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $62424571d4d73005$export$5efaf8444170fe75)(exception.value);
                    allMatchedUUIDs.push(...matchedUUIDs);
                    return {
                        ...exception,
                        value: normalized
                    };
                });
                if (allMatchedUUIDs.length > 0) {
                    if (!updatedEvent.tags) updatedEvent.tags = {};
                    updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                }
            }
            return updatedEvent;
        },
        attachStacktrace: true,
        ignoreErrors: ignoreErrors
    });
    $26a7abafe1ae99d6$var$sentryClient = importedSentry;
};
const $26a7abafe1ae99d6$var$getSentryClient = async ()=>{
    if (!$26a7abafe1ae99d6$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $26a7abafe1ae99d6$export$d8bd0edf6c978788();
    return $26a7abafe1ae99d6$var$sentryClient;
};
const $26a7abafe1ae99d6$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') scope.setTag('experience', name);
        sentryClient.captureException(exception, scope);
    });
};
async function $26a7abafe1ae99d6$export$de29810e0b4aa46e(crumb) {
    if (!(0, $dh538.fg)('rovo_chat_enable_additional_breadcrumbs')) // do not add breadcrumbs if the feature flag is disabled
    return;
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.addBreadcrumb(typeof crumb === 'string' ? {
        message: crumb
    } : crumb);
}
module.exports["setupSentryClient"] = $26a7abafe1ae99d6$export$d8bd0edf6c978788;
module.exports["logException"] = $26a7abafe1ae99d6$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $26a7abafe1ae99d6$export$de29810e0b4aa46e;

});

parcelRegister("8Igpw", function(module, exports) {
const $43e5bdc11d95b8bf$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $43e5bdc11d95b8bf$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $43e5bdc11d95b8bf$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $43e5bdc11d95b8bf$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $43e5bdc11d95b8bf$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        const statusCode = err instanceof $43e5bdc11d95b8bf$var$HttpApiError ? err?.errorAttributes?.statusCode : undefined;
        throw new $43e5bdc11d95b8bf$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $43e5bdc11d95b8bf$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $43e5bdc11d95b8bf$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $43e5bdc11d95b8bf$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $43e5bdc11d95b8bf$export$9f229e40eb65abfc;
module.exports["FetchError"] = $43e5bdc11d95b8bf$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $43e5bdc11d95b8bf$export$a38d93aa782475f6;

});

parcelRegister("6jYyB", function(module, exports) {

let $49a37dcba4f239e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49a37dcba4f239e3$var$load("h3ABO"),
    $49a37dcba4f239e3$var$load("kC80R")
]).then(()=>parcelRequire('7hGsm'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("TwPkE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $19e5e9ef880dfbce$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $19e5e9ef880dfbce$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $42omo.createContext)({
    propertiesRef: {
        current: {
            ...$19e5e9ef880dfbce$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $19e5e9ef880dfbce$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $42omo.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $19e5e9ef880dfbce$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $42omo.useRef)({
        ...$19e5e9ef880dfbce$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $42omo.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $19e5e9ef880dfbce$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $42omo.useContext)($19e5e9ef880dfbce$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $42omo.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$1aefd27d2ed3c1c9, {
                mode: mode,
                children: children
            })
        })
    });
};
const $19e5e9ef880dfbce$export$ab8aa3dfd687f012 = ()=>{
    return (0, $42omo.useContext)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $19e5e9ef880dfbce$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $19e5e9ef880dfbce$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $19e5e9ef880dfbce$export$ab8aa3dfd687f012;

});

parcelRegister("jA9SA", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $eb66f40a0f078927$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias'
};
module.exports["AI_MATE_ATTRIBUTES"] = $eb66f40a0f078927$export$8cffc8b2c93affd4;

});

parcelRegister("bQGO7", function(module, exports) {

var $3pfAb = parcelRequire("3pfAb");

const $7940b633dc028a3e$export$85183a312807388d = (0, $3pfAb.FabricChannel).aiMate;
var $7940b633dc028a3e$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    return AUTOSUGGEST_SOURCE;
}({});
module.exports["ANALYTICS_CHANNEL"] = $7940b633dc028a3e$export$85183a312807388d;
module.exports["AUTOSUGGEST_SOURCE"] = $7940b633dc028a3e$export$406073150b1a408;

});

parcelRegister("6eZqW", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8m4tT = parcelRequire("8m4tT");


var $8nxxM = parcelRequire("8nxxM");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");

const $92afea9a8f6a2cee$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};


const $deb7030063275628$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $deb7030063275628$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $deb7030063275628$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($deb7030063275628$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $deb7030063275628$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $deb7030063275628$var$renderNode(state, child, i);
    });
};
const $deb7030063275628$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $deb7030063275628$var$renderNode(state, node, 0);
    state.write(' ');
};
const $deb7030063275628$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $92afea9a8f6a2cee$export$5be26e657c035da4)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $deb7030063275628$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $92afea9a8f6a2cee$export$5be26e657c035da4)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($deb7030063275628$var$isHeaderRow(node) || $deb7030063275628$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $92afea9a8f6a2cee$export$5be26e657c035da4)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $92afea9a8f6a2cee$export$5be26e657c035da4)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $deb7030063275628$export$2e2bcd8739ae039 = $deb7030063275628$var$tableNodes;



var $bd943 = parcelRequire("bd943");




const $6ff1f24202635c31$export$8ef94ae42a3729bd = 1;
const $6ff1f24202635c31$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $6ff1f24202635c31$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $5SAOw.Node))) return $6ff1f24202635c31$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $6ff1f24202635c31$export$d445360e2a3c026b(order) ?? $6ff1f24202635c31$export$8ef94ae42a3729bd;
};


/**
 * A replacement for `String.repeat` until it becomes widely available.
 */ function $74c7a8487430b8e3$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $74c7a8487430b8e3$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\+[ ]|[\-*>])/, '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*\d+)\.\s/, '$1\\. ');
    if (insideTable) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $74c7a8487430b8e3$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
function $74c7a8487430b8e3$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($74c7a8487430b8e3$var$SPECIAL_CHARACTERS, '');
    Array.from(node.childNodes).forEach((child)=>$74c7a8487430b8e3$var$removeSpecialCharacters(child));
}
function $74c7a8487430b8e3$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $74c7a8487430b8e3$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const usernameMatch = title.match(/^@(.*?)$/);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            const idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}


const $e985dce6263f3bba$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $74c7a8487430b8e3$export$345d822805ab3239)('`', length);
    };
})();
class $e985dce6263f3bba$export$61055fa707e69319 extends (0, $42JDa.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return /(^|\n)$/.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp, @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/^`/)) text = ' ' + text;
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/`$/)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore -next-line
        super($e985dce6263f3bba$export$695720b7e7a61533, $e985dce6263f3bba$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $e985dce6263f3bba$export$695720b7e7a61533;
        this.marks = $e985dce6263f3bba$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $e985dce6263f3bba$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $6ff1f24202635c31$export$4ea3c6bbdf8f7944)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $5SAOw.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = `blob:${(0, $bd943.MEDIA_BASE_URL_STAGING)}/?`;
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $74c7a8487430b8e3$export$560888d6fe0cfe97)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $74c7a8487430b8e3$export$560888d6fe0cfe97)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $74c7a8487430b8e3$export$560888d6fe0cfe97)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$e985dce6263f3bba$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                // Ensure localId is explicitly set to null if not present
                const attributes = {
                    ...node.attrs,
                    localId: node.attrs.localId ?? null
                };
                state.idMap[id] = {
                    type: 'date',
                    attributes: attributes
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $e985dce6263f3bba$export$695720b7e7a61533 = {
    ...$e985dce6263f3bba$var$editorNodes,
    ...(0, $deb7030063275628$export$2e2bcd8739ae039)
};
const $e985dce6263f3bba$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};


/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $8m4tT.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $fb0b992a34319cb0$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $fb0b992a34319cb0$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $fb0b992a34319cb0$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $fb0b992a34319cb0$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $fb0b992a34319cb0$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const markdownSerializerState = new (0, $e985dce6263f3bba$export$61055fa707e69319)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $8nxxM.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}
module.exports["convertProsemirrorToMarkdown"] = $fb0b992a34319cb0$export$cc6cac500a4da966;
module.exports["convertProsemirrorNodeToMarkdown"] = $fb0b992a34319cb0$export$3d24004275aefeab;

});

parcelRegister("8nxxM", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

class $13b081699855d8a3$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $5SAOw.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}
module.exports["ProseMirrorContentStatistics"] = $13b081699855d8a3$export$acf14785d7d5b1be;

});

parcelRegister("jOIil", function(module, exports) {
class $3057f4cb0fd3db76$var$EventHub {
    /**
   * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
   *
   * @param {object} params - The subscription parameters.
   * @param {T} params.event - The name of the event to subscribe to.
   * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
   * It receives the event data as its parameter.
   * @returns {object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
   *
   * @example
   * // Subscribing to an event
   * const subscription = eventHub.subscribe({
   *   event: 'start prompt',
   *   callback: (data) => {
   *     console.log('Received start prompt event:', data);
   *   },
   * });
   *
   * // Later, to unsubscribe
   * subscription.unsubscribe();
   */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
   * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event to the editor
   * eventHub.publishToEditor({
   *   event: 'start prompt',
   *   data: {
   *     prompt: 'issue reformatter',
   *     targetEditorId,
   *     analyticSourceId: 'jiraIssueReformatterExternalButton',
   *   },
   * });
   */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
   * Publishes an event originating from the editor, invoking all registered subscribers for that event.
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event from the editor
   * eventHub.publishFromEditor({
   *   event: 'replace title in confluence',
   *   data: {
   *     analyticSourceId: 'confluenceTitleToolbar',
   *     sourceEditorId,
   *     title: textContent,
   *   },
   * });
   */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
}
const $3057f4cb0fd3db76$export$e17a52e5da72c4cb = new $3057f4cb0fd3db76$var$EventHub();
module.exports["eventHub"] = $3057f4cb0fd3db76$export$e17a52e5da72c4cb;

});

parcelRegister("b4emg", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hbEec = parcelRequire("hbEec");

const $8841f32d2d46ed1f$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $8841f32d2d46ed1f$export$d109ab46c9575565;

});

parcelRegister("b4zhJ", function(module, exports) {

var $dM1Gg = parcelRequire("dM1Gg");


var $42omo = parcelRequire("42omo");


var $dWCFT = parcelRequire("dWCFT");

const $4b5152b7d142b759$var$isClickable = (props)=>!!props.onClick;
class $4b5152b7d142b759$export$6341f9a885713487 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dM1Gg.DateLozenge), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            onClick: $4b5152b7d142b759$var$isClickable(this.props) ? this.handleOnClick : undefined,
            color: this.props.color
        }, this.renderContent());
    }
    constructor(...args){
        super(...args);
        this.handleOnClick = (event)=>{
            if ($4b5152b7d142b759$var$isClickable(this.props)) this.props.onClick(this.props.value, event);
        };
        this.renderContent = ()=>{
            if (this.props.children) {
                if (typeof this.props.children === 'function') return(// prettier-ignore
                // eslint-disable-next-line @typescript-eslint/ban-types
                this.props.children(this.props));
                return this.props.children;
            }
            return (0, $dWCFT.default)(this.props.value, this.props.format || '');
        };
    }
}
$4b5152b7d142b759$export$6341f9a885713487.displayName = 'Date';
$4b5152b7d142b759$export$6341f9a885713487.defaultProps = {
    format: 'dd/MM/yyyy',
    color: 'grey'
};
module.exports["Date"] = $4b5152b7d142b759$export$6341f9a885713487;

});

parcelRegister("dM1Gg", function(module, exports) {
/* DateLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $6603fd6b25dc5551$var$baseStyles = null;
const $6603fd6b25dc5551$var$onClickStyles = null;
const $6603fd6b25dc5551$var$colorStyles = {
    red: "_bfhk1vk5 _syaz9lu1 _irr31rtt",
    yellow: "_bfhkibhp _syazfb2s _irr31773",
    blue: "_bfhk1s93 _syaz16jw _irr31dy8",
    green: "_bfhkn729 _syazh55r _irr31wnw",
    purple: "_bfhkp2ly _syazqmo9 _irr31nm4",
    grey: "_bfhki8nm _syazi7uo _irr3plhp"
};
const $6603fd6b25dc5551$export$a9273d5fc6f7142c = (props)=>{
    const { className: className, color: color = 'grey', children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...rest,
        className: (0, $gMc0m.default)([
            "_2rkofajl _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od",
            props.onClick && "_80omtlke",
            $6603fd6b25dc5551$var$colorStyles[color],
            className
        ]),
        role: "button"
    }, children);
};
module.exports["DateLozenge"] = $6603fd6b25dc5551$export$a9273d5fc6f7142c;

});

parcelRegister("fi2El", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::619fb4ad6cec2107e8d1f4fc5bb05b5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b21a97a402c82df9$var$_react = $b21a97a402c82df9$var$_interopRequireDefault((parcelRequire("42omo")));

var $b21a97a402c82df9$var$_baseNew = $b21a97a402c82df9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b21a97a402c82df9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b21a97a402c82df9$var$HistoryIcon = (props)=>/*#__PURE__*/ $b21a97a402c82df9$var$_react.default.createElement($b21a97a402c82df9$var$_baseNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$b21a97a402c82df9$var$HistoryIcon.displayName = 'HistoryIcon';
var $b21a97a402c82df9$var$_default = module.exports.default = $b21a97a402c82df9$var$HistoryIcon;

});

parcelRegister("d7r2R", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $376a36c4bbddbe1c$var$Loading = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: props.alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
var $376a36c4bbddbe1c$export$2e2bcd8739ae039 = $376a36c4bbddbe1c$var$Loading;
module.exports["default"] = $376a36c4bbddbe1c$export$2e2bcd8739ae039;

});

parcelRegister("hUyPY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $c6GJD = parcelRequire("c6GJD");


var $4u5NT = parcelRequire("4u5NT");


var $9tntP = parcelRequire("9tntP");


var $j2DyP = parcelRequire("j2DyP");


var $1yaYZ = parcelRequire("1yaYZ");


var $kIvLT = parcelRequire("kIvLT");


var $16lEl = parcelRequire("16lEl");

var $a0b22d0a467d60f5$var$_ExperienceTrackerHandler;
const $a0b22d0a467d60f5$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
class $a0b22d0a467d60f5$export$5a92a056565f01cc {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$a0b22d0a467d60f5$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $c6GJD.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $a0b22d0a467d60f5$export$5a92a056565f01cc.instance = new $a0b22d0a467d60f5$export$5a92a056565f01cc(dropEvents);
        }
        return $a0b22d0a467d60f5$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $a0b22d0a467d60f5$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $9tntP.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $j2DyP.isClientFetchError)(event.error)) preventSendingLogException = true;
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        fastModeEnabled: fastModeEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($a0b22d0a467d60f5$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = attributes?.touchpointSource;
                    const teamName = attributes?.teamName;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $1yaYZ.logException)({
                        exception: error,
                        name: event.name,
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if (event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort') // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $4u5NT.addSpanToAll)('custom', `exp-${event.name}`, $a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    // Only add duration if event is SuccessEvent or FailEvent
                    ...(event.action === 'taskSuccess' || event.action === 'taskFail') && {
                        duration: event.duration
                    },
                    ...event.action === 'taskFail' && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
}
$a0b22d0a467d60f5$var$_ExperienceTrackerHandler = $a0b22d0a467d60f5$export$5a92a056565f01cc;
$a0b22d0a467d60f5$export$5a92a056565f01cc.instance = void 0;
$a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack = [];
const $a0b22d0a467d60f5$export$63af6e7bbb4f375d = ()=>{
    return (0, $42omo.useCallback)((componentLabelStack)=>{
        $a0b22d0a467d60f5$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $a0b22d0a467d60f5$export$412c53791574f6f0 = (params)=>{
    (0, $fBMbo.di)((0, $kIvLT.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent, mode: conversationAssistantUIMode } = (0, $kIvLT.useAnalytics)();
    const getNameOverride = (0, $42omo.useCallback)((name)=>{
        switch(conversationAssistantUIMode){
            case 'mini-modal':
                return `${name}.${(0, $16lEl.ExperienceNamePostfix).MINI_MODAL}`;
            default:
                return name;
        }
    }, [
        conversationAssistantUIMode
    ]);
    (0, $42omo.useMemo)(()=>{
        const experienceTracker = $a0b22d0a467d60f5$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $42omo.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            name: !!failParams.name ? getNameOverride(failParams.name) : failParams.name,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: !!succeedParams.name ? getNameOverride(succeedParams.name) : succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: !!startParams.name ? getNameOverride(startParams.name) : startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: !!abortParams.name ? getNameOverride(abortParams.name) : abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: !!stopOnErrorParams.name ? getNameOverride(stopOnErrorParams.name) : stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($a0b22d0a467d60f5$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource,
        getNameOverride
    ]);
    return experienceTrackerProxy;
};
module.exports["useUFOLabelStackSetter"] = $a0b22d0a467d60f5$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $a0b22d0a467d60f5$export$412c53791574f6f0;

});

parcelRegister("gjr93", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $ygGKm = parcelRequire("ygGKm");


var $cgtv4 = parcelRequire("cgtv4");

var $2fd64f51ce2261f9$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});


const $574c86f95ed7997c$var$state = (0, $1P1Tu.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder
                });
            }
    }
});
const $574c86f95ed7997c$export$e638cf26ae51308d = (0, $9zUhf.createHook)($574c86f95ed7997c$var$state);
const $574c86f95ed7997c$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $ygGKm.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $574c86f95ed7997c$export$21b2d5ca0689f678 = ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $574c86f95ed7997c$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const insertHighlightActionsEditorPlaceholder = (0, $42omo.useCallback)((prompt)=>{
        const highlightActionsPlaceholderPrompt = formatMessage((0, $2fd64f51ce2261f9$export$2e2bcd8739ae039).highlightActionsPlaceholderPrompt);
        const placeholderData = $574c86f95ed7997c$var$getHighlightActionPlaceholderData(prompt, highlightActionsPlaceholderPrompt);
        setHighlightActionsEditorPlaceholder(placeholderData);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $42omo.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $574c86f95ed7997c$export$21b2d5ca0689f678;

});

parcelRegister("5MO1q", function(module, exports) {
const $bc280b458a56ce28$export$e8114853eca81277 = 'ai-mate';
const $bc280b458a56ce28$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $bc280b458a56ce28$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $bc280b458a56ce28$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $bc280b458a56ce28$export$333e4f57333eadfa;

});

parcelRegister("29BPs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $flpNp = parcelRequire("flpNp");

const $e1cff82b24aa7fdd$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $42omo.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $42omo.useState)(null);
    const [error, setError] = (0, $42omo.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const mutate = (0, $42omo.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            setError(apiError);
            onErrorRef.current?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};
module.exports["useMutation"] = $e1cff82b24aa7fdd$export$609860bf8b0084c;

});

parcelRegister("flpNp", function(module, exports) {
class $1d075fa469bb0891$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $1d075fa469bb0891$export$89d83cc97c52a37 = (error)=>error instanceof $1d075fa469bb0891$export$f2e832acab1bdd79;
const $1d075fa469bb0891$export$3c02d1a328d4d808 = (error)=>{
    if ($1d075fa469bb0891$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $1d075fa469bb0891$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $1d075fa469bb0891$export$f2e832acab1bdd79;
module.exports["isApiError"] = $1d075fa469bb0891$export$89d83cc97c52a37;
module.exports["mapErrorToApiError"] = $1d075fa469bb0891$export$3c02d1a328d4d808;

});

parcelRegister("h26dv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $4u5NT = parcelRequire("4u5NT");


var $hUyPY = parcelRequire("hUyPY");


var $ljUdP = parcelRequire("ljUdP");


var $8Igpw = parcelRequire("8Igpw");

// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
const $8485b8d4788fac0e$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};


const $e391ccd494b2887b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};


async function* $daf6340d0b79c55b$export$1f24b2b263bcfa75(response) {
    const reader = (0, $e391ccd494b2887b$export$f6383c3ea1307da9)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                yield JSON.parse(chunk);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}



const $647a1bfa8247ed45$var$parseSSEMessage = (message)=>{
    const parsed = {};
    const dataLines = [];
    for (const line of message.split('\n')){
        const trimmedLine = line.trim();
        const colonIndex = trimmedLine.indexOf(':');
        if (trimmedLine && colonIndex !== -1) {
            const field = trimmedLine.substring(0, colonIndex);
            const value = trimmedLine.substring(colonIndex + 1).trimStart();
            switch(field){
                case 'event':
                    parsed.eventType = value;
                    break;
                case 'data':
                    dataLines.push(value);
                    break;
                case 'id':
                    parsed.id = value;
                    break;
                default:
                    break;
            }
        }
    }
    if (dataLines.length) parsed.data = dataLines.join('\n');
    return parsed;
};
async function* $647a1bfa8247ed45$export$6dab2f647580dc69(response) {
    const reader = (0, $e391ccd494b2887b$export$f6383c3ea1307da9)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const combined = `${remainder}${value}`;
            const parts = combined.split('\n\n'); // SSE messages are separated by double newlines
            // the last part may be incomplete — keep it for the next read
            remainder = parts.pop() ?? '';
            for (const chunk of parts)try {
                const parsed = $647a1bfa8247ed45$var$parseSSEMessage(chunk);
                if (parsed.data) {
                    const parsedData = JSON.parse(parsed.data);
                    yield {
                        __isSSEWrapper: true,
                        data: parsedData,
                        id: parsed.id,
                        eventType: parsed.eventType
                    };
                }
            } catch  {
            // ignore malformed JSON; keep streaming future valid messages
            }
        }
        // If the stream just ended and we still have a remainder, try to parse it once.
        if (doneStreaming && remainder) try {
            const parsed = $647a1bfa8247ed45$var$parseSSEMessage(remainder);
            if (parsed.data) {
                const parsedData = JSON.parse(parsed.data);
                yield {
                    __isSSEWrapper: true,
                    data: parsedData,
                    id: parsed.id,
                    eventType: parsed.eventType
                };
            }
        } catch  {
        // ignore malformed tail
        } finally{
            remainder = '';
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}



var $flpNp = parcelRequire("flpNp");




const $839038eaaf7c5a3d$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $839038eaaf7c5a3d$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $839038eaaf7c5a3d$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $839038eaaf7c5a3d$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    throw new (0, $flpNp.ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $8Igpw.getTraceIdFromResponse)(response)
    });
};
const $839038eaaf7c5a3d$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $839038eaaf7c5a3d$var$processErrorResponse({
        response: response
    });
    return response;
};



var $99vXA = parcelRequire("99vXA");


var $aclUh = parcelRequire("aclUh");

const $7b2e91008351c623$var$PRODUCT_HEADER = 'x-product';
const $7b2e91008351c623$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $7b2e91008351c623$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
class $7b2e91008351c623$export$40a7802808e2fbe3 {
    createHeaders(init) {
        return new Headers({
            [$7b2e91008351c623$var$PRODUCT_HEADER]: this.config.product,
            [$7b2e91008351c623$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.headers || {},
            ...init || {}
        });
    }
    async fetch({ path: path, options: options, holdName: holdName }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = configBaseUrl;
        const requestUrl = (0, $839038eaaf7c5a3d$export$4c25481b843feb0b)(baseUrl, path);
        const startTime = performance.now();
        const response = await window.fetch(requestUrl, {
            credentials: configCredentials,
            ...options
        });
        if (this.config.labelStack) {
            // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
            // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
            // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
            const endTime = performance.now();
            (0, $4u5NT.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
        }
        return (0, $839038eaaf7c5a3d$export$21fcb6cfd5628534)({
            response: response
        });
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async fetchStream(options, config) {
        const response = await this.fetch(options);
        const contentType = response.headers.get('content-type') ?? '';
        const headerSuggestsSSE = config?.useSSE && contentType.includes('text/event-stream');
        return {
            responseData: {
                traceId: (0, $8Igpw.getTraceIdFromResponse)(response)
            },
            generator: headerSuggestsSSE ? (0, $647a1bfa8247ed45$export$6dab2f647580dc69)(response) : (0, $daf6340d0b79c55b$export$1f24b2b263bcfa75)(response)
        };
    }
    constructor(props){
        this.config = void 0;
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
}
const $7b2e91008351c623$var$getHref = (product)=>{
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window?.location?.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
class $7b2e91008351c623$export$a522c5f4ccda1c94 extends $7b2e91008351c623$export$40a7802808e2fbe3 {
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, appFilters: appFilters, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, browserContextSanitizer: browserContextSanitizer, optInSSEStream: optInSSEStream = false }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$7b2e91008351c623$var$CHANNEL_ID_HEADER]: 'rovo-chat',
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        // Check if the URL is blocklisted
        const browserUrl = browserContext?.context?.browserUrl;
        const isBlocklisted = browserUrl && browserContextSanitizer ? browserContextSanitizer.isBlocklisted(browserUrl) : false;
        // Determine the URL to send to the backend
        // If blocklisted, send empty URL to ensure the site is not sent to the backend
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        let url;
        if (isBlocklisted || browserContext?.context?.browserUrl === 'NO-URL' && (0, $c6GJD.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) url = '';
        else if (browserContext?.context?.browserUrl) url = browserContext.context.browserUrl;
        else url = $7b2e91008351c623$var$getHref(this.getConfig().product) ?? '';
        const body = {
            content: message,
            context: {
                // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
                // instead it depends on prompt intent to use it,
                // with useCurrentBrowsingContext we can ensure it is always used
                browser_url: url,
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
                ...browserContext && !isBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext,
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                ...knowledgeOverride
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
            // don't allow store message if feature flag is off
            store_message: (0, $dh538.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {})
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async reconnectToMessageStream({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, controller: controller }) {
        const headers = this.createHeaders();
        // Add Last-Event-ID header if available
        if (lastEventId) headers.set('Last-Event-ID', lastEventId);
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/stream/sse`,
            options: options
        }, {
            useSSE: true
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools, optInSSEStream: optInSSEStream = false }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const url = window?.location?.href;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            confirmed_tools: confirmed_tools,
            context: {
                browser_url: url
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            store_message: false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const rawChat = await this.fetchJson({
            path: `/rovo/v1/chat/conversation/${conversationId}/messages`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]-messages'
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>// Must be converted into StreamResponse
            (0, $ljUdP.isHumanMessage)(message) ? message : (0, $aclUh.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options,
            holdName: 'rovo-v1-agents-accountid-[identityAccountId]'
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async createConversationChannel(options) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    name: options?.name ?? (0, $99vXA.generateConversationName)(),
                    dialogues: options?.dialogues ?? undefined
                })
            },
            holdName: 'rovo-v1-chat-conversation'
        });
    }
    async getConversationChannels() {
        // Clean up `ConversationChannel[] | { items: ConversationChannel[] }` when fg('rovo_convo_ai_migration') is removed
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'rovo-v1-chat-conversations'
        });
        return result.items;
    }
    updateConversationChannel(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(payload)
            },
            holdName: 'rovo-v1-chat-conversation-[id]'
        });
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            holdName: 'rovo-v1-chat-conversation-[id]-action'
        });
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options,
            holdName: 'rovo-v1-conversation-starters-agent-starter-suggestion'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options,
            holdName: 'rovo-v1-conversation-starters-page-contextual'
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options,
            holdName: 'api-ai-v2-ai-feature-convo-starters'
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options,
            holdName: 'api-v2-configuration-web-search-ai'
        });
        return result;
    }
    async getPrompts() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
        return result;
    }
    async getPrompt(promptId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-[promptId]'
        });
    }
    async bulkGetPrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-get',
            options: options,
            holdName: 'api-v2-prompts-bulk-get'
        });
    }
    async createPrompt(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
    }
    async updatePrompt(promptId, payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-update'
        });
    }
    async addPromptsToLibrary(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: '/api/v2/prompts/add-to-library',
            options: options,
            holdName: 'api-v2-prompts-add-to-library'
        });
    }
    async deletePrompt(shareId) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers
        };
        await this.fetch({
            path: `/api/v2/prompts/${shareId}`,
            options: options,
            holdName: 'api-v2-prompts-delete'
        });
    }
    async favoritePrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: `/api/v2/prompts/favorite`,
            options: options,
            holdName: 'api-v2-prompts-favorite'
        });
    }
    constructor(props){
        super(props);
        this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-actions'
            });
            return response.actions;
        };
        this.getAgentKnowledgeConfiguration = ()=>{
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-knowledge'
            });
        };
        this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v2-permissions-agents-[agentId]'
            });
        };
        this.getRecommendedAgents = ({ limit: limit, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString()
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-recommend-v2'
            });
        };
        this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]-debug-logs'
            });
            return response.items;
        };
        this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: `/rovo/v1/chat/message/file/validate`,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-message-file-validate'
            });
        };
        this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/message/file`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                },
                holdName: 'rovo-v1-chat-message-file'
            });
            return response;
        };
        this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-agent-playground-chat-stream'
            });
        };
        this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-chat-conversations'
            });
        };
        this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-tools'
            });
        };
        this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-language-models'
            });
        };
        this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-prompts'
            });
        };
        this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-generated-content'
            });
        };
        this.getRovoUserSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.updateRovoUserSettings = async (settings)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(settings)
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.getRovoMemories = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories'
            });
        };
        this.answerNow = async (conversationId, messageId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/answer-now`,
                options: options,
                holdName: 'rovo-v1-chat-conversation-message-answer-now'
            });
        };
        this.deleteRovoMemory = async (memoryId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/${memoryId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-[memoryId]'
            });
        };
    }
}
const $7b2e91008351c623$var$AssistanceServiceContext = /*#__PURE__*/ (0, $42omo.createContext)(new $7b2e91008351c623$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $7b2e91008351c623$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)($7b2e91008351c623$var$AssistanceServiceContext.Provider, {
        value: value,
        children: children
    });
const $7b2e91008351c623$export$7e31a1844ebbaf85 = (props)=>{
    (0, $fBMbo.di)((0, $42omo.useContext), $7b2e91008351c623$export$a522c5f4ccda1c94);
    const service = (0, $42omo.useContext)($7b2e91008351c623$var$AssistanceServiceContext);
    (0, $8485b8d4788fac0e$export$caa27b16709bc2df)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    return new $7b2e91008351c623$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers
    });
};
const $7b2e91008351c623$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $fBMbo.di)($7b2e91008351c623$export$a522c5f4ccda1c94, (0, $hUyPY.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $42omo.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $42omo.useMemo)(()=>{
            return new $7b2e91008351c623$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            headers,
            assistanceServiceParams.minionAlias
        ]);
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};
module.exports["AssistanceServiceImpl"] = $7b2e91008351c623$export$a522c5f4ccda1c94;
module.exports["AssistanceServiceProvider"] = $7b2e91008351c623$export$8fe647eb935c33db;
module.exports["useAssistanceService"] = $7b2e91008351c623$export$7e31a1844ebbaf85;
module.exports["createHookWithAssistanceService"] = $7b2e91008351c623$export$5a9ea20fc196ec62;

});

parcelRegister("ljUdP", function(module, exports) {

var $5MO1q = parcelRequire("5MO1q");


var $flpNp = parcelRequire("flpNp");

const $35329f6c3dcf5d43$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $35329f6c3dcf5d43$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $35329f6c3dcf5d43$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
var $35329f6c3dcf5d43$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $35329f6c3dcf5d43$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $35329f6c3dcf5d43$export$fb661125ffb29bd6 = (message)=>{
    return $35329f6c3dcf5d43$export$a69fab2afb88c2eb(message) || $35329f6c3dcf5d43$export$6f965deda7f0960c(message) || $35329f6c3dcf5d43$export$b4631726cbc1440a(message);
};
const $35329f6c3dcf5d43$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $35329f6c3dcf5d43$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $35329f6c3dcf5d43$export$a6e5100ca2770191 = (message)=>message instanceof Object && $35329f6c3dcf5d43$export$6f965deda7f0960c(message.message);
const $35329f6c3dcf5d43$export$5c1c15675df13ae5 = (message)=>$35329f6c3dcf5d43$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $35329f6c3dcf5d43$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $35329f6c3dcf5d43$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $35329f6c3dcf5d43$export$1e1cf807ece63df4 = (message)=>$35329f6c3dcf5d43$export$d422a2733a3b5def(message) && message.message?.message_template === $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
const $35329f6c3dcf5d43$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $35329f6c3dcf5d43$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $35329f6c3dcf5d43$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $35329f6c3dcf5d43$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $35329f6c3dcf5d43$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $35329f6c3dcf5d43$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $35329f6c3dcf5d43$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $35329f6c3dcf5d43$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $35329f6c3dcf5d43$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $35329f6c3dcf5d43$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $35329f6c3dcf5d43$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $35329f6c3dcf5d43$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $35329f6c3dcf5d43$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $35329f6c3dcf5d43$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $35329f6c3dcf5d43$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $35329f6c3dcf5d43$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $35329f6c3dcf5d43$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $35329f6c3dcf5d43$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $35329f6c3dcf5d43$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $35329f6c3dcf5d43$export$b00dd9d0560e29d2 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $35329f6c3dcf5d43$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $35329f6c3dcf5d43$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE');
const $35329f6c3dcf5d43$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($35329f6c3dcf5d43$export$7898cc38956b9052(message) || $35329f6c3dcf5d43$export$bb608d13a1268633(message));
const $35329f6c3dcf5d43$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($35329f6c3dcf5d43$export$46e0fb5e4b019a49(message)) return false;
    if ($35329f6c3dcf5d43$export$cde91b49af35d559(message)) return false;
    if ($35329f6c3dcf5d43$export$6f74311d40862a9f(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $35329f6c3dcf5d43$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $35329f6c3dcf5d43$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $35329f6c3dcf5d43$export$b8391261162989d9 = (message)=>$35329f6c3dcf5d43$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $35329f6c3dcf5d43$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $35329f6c3dcf5d43$export$6ce1ccc24e75456f = (error)=>(0, $flpNp.isApiError)(error) && error.errorAttributes?.errorCode === $35329f6c3dcf5d43$export$5945515082cc2cbf;
const $35329f6c3dcf5d43$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $35329f6c3dcf5d43$export$bc96a6a479480590 = (error)=>(0, $flpNp.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $35329f6c3dcf5d43$export$f8b1b75846492611 = (error)=>(0, $flpNp.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $35329f6c3dcf5d43$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
const $35329f6c3dcf5d43$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
function $35329f6c3dcf5d43$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["isSSEMessage"] = $35329f6c3dcf5d43$export$f78edfe5a93b58af;
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
module.exports["isHumanMessage"] = $35329f6c3dcf5d43$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $35329f6c3dcf5d43$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $35329f6c3dcf5d43$export$b4631726cbc1440a;
module.exports["isAgentResponse"] = $35329f6c3dcf5d43$export$a6e5100ca2770191;
module.exports["isInProgressStreamResponse"] = $35329f6c3dcf5d43$export$5c1c15675df13ae5;
module.exports["isStreamError"] = $35329f6c3dcf5d43$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $35329f6c3dcf5d43$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $35329f6c3dcf5d43$export$e45102edbc73b240;
module.exports["isStreamReasoningPart"] = $35329f6c3dcf5d43$export$51a109436d382715;
module.exports["isStreamActionPart"] = $35329f6c3dcf5d43$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $35329f6c3dcf5d43$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $35329f6c3dcf5d43$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $35329f6c3dcf5d43$export$7d94ce53d589f586;
module.exports["isStreamResearchStart"] = $35329f6c3dcf5d43$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $35329f6c3dcf5d43$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $35329f6c3dcf5d43$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $35329f6c3dcf5d43$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $35329f6c3dcf5d43$export$cde91b49af35d559;
module.exports["isStreamResearchStepTitleShort"] = $35329f6c3dcf5d43$export$ac74da022f74040a;
module.exports["isStreamSkillStart"] = $35329f6c3dcf5d43$export$7898cc38956b9052;
module.exports["isStreamSkillEnd"] = $35329f6c3dcf5d43$export$bb608d13a1268633;
module.exports["isStreamFastModeResponseAvailable"] = $35329f6c3dcf5d43$export$b65c73c7e2d8d96f;
module.exports["isStreamFastModeEnabled"] = $35329f6c3dcf5d43$export$40cf419186312161;
module.exports["isStreamResearchStepSource"] = $35329f6c3dcf5d43$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $35329f6c3dcf5d43$export$cfccfd17b68ccb0;
module.exports["isStreamReconnectSupportPart"] = $35329f6c3dcf5d43$export$c679ee34f7312895;
module.exports["isStreamAnswerGenerationType"] = $35329f6c3dcf5d43$export$b00dd9d0560e29d2;
module.exports["isStreamDynamicLayoutSubAgent"] = $35329f6c3dcf5d43$export$5fa02529cd2ab34c;
module.exports["isStreamResearchPayload"] = $35329f6c3dcf5d43$export$46e0fb5e4b019a49;
module.exports["isStreamSkill"] = $35329f6c3dcf5d43$export$6f74311d40862a9f;
module.exports["isStreamTrace"] = $35329f6c3dcf5d43$export$fd5a05be03f147a0;
module.exports["isFollowUpMessage"] = $35329f6c3dcf5d43$export$aeae5b4fda357302;
module.exports["isStreamHeartbeat"] = $35329f6c3dcf5d43$export$b46beea5c82aa1b9;
module.exports["isActionExecutedSuccessfully"] = $35329f6c3dcf5d43$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $35329f6c3dcf5d43$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $35329f6c3dcf5d43$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $35329f6c3dcf5d43$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $35329f6c3dcf5d43$export$bc96a6a479480590;
module.exports["isHipaaError"] = $35329f6c3dcf5d43$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $35329f6c3dcf5d43$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $35329f6c3dcf5d43$export$b454081350f4a578;
module.exports["isConfirmAction"] = $35329f6c3dcf5d43$export$4af48296a8d61cec;

});

parcelRegister("99vXA", function(module, exports) {
const $54861eb441be5d90$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $54861eb441be5d90$export$11cc4786742ed7c2;

});

parcelRegister("aclUh", function(module, exports) {

var $ljUdP = parcelRequire("ljUdP");

const $68019d45b4210062$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $68019d45b4210062$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $68019d45b4210062$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $68019d45b4210062$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $68019d45b4210062$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $68019d45b4210062$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (cur == null || typeof cur !== 'object') return undefined;
        cur = cur[key];
    }
    return cur;
};
const $68019d45b4210062$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = obj && typeof obj === 'object' ? obj : {};
    return {
        ...base,
        [head]: $68019d45b4210062$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $68019d45b4210062$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $68019d45b4210062$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $68019d45b4210062$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $68019d45b4210062$var$toPathArr(p);
            const prevVal = $68019d45b4210062$var$getAtPath(prevData, pathArr);
            const nextVal = $68019d45b4210062$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            base = $68019d45b4210062$var$setAtPath(base, pathArr, accumulated);
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $68019d45b4210062$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key } = actionPart.message;
    const existingActionIndex = actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $68019d45b4210062$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $68019d45b4210062$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $68019d45b4210062$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $68019d45b4210062$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $68019d45b4210062$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $68019d45b4210062$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $68019d45b4210062$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $68019d45b4210062$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $68019d45b4210062$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $68019d45b4210062$var$removeSensitiveDataAgentResponse(message.message)
    });
const $68019d45b4210062$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads
    };
};
const $68019d45b4210062$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $ljUdP.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $68019d45b4210062$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $68019d45b4210062$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $68019d45b4210062$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $68019d45b4210062$export$efd4f6b5d168b654;
module.exports["createHumanMessage"] = $68019d45b4210062$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $68019d45b4210062$export$3220a4ff7b3a96df;

});

parcelRegister("i1Nyn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $3527ba50fc1c4fde$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        contentTargets: {},
        currentTargetId: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const currentAIFeatureContextState = getState().aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                if ((0, $dh538.fg)('aifc_multiple_context')) {
                    // New mode: targets is always an array
                    const targetList = targets;
                    // If activeTargetId provided, find it; otherwise return first target
                    if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                    return targetList[0];
                }
                // Legacy mode: single target
                return targets;
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = (0, $dh538.fg)('aifc_multiple_context') ? targets : [
                        targets
                    ];
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const entries = getState().contentTargets;
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                if (entries['staging-area']) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                if ((0, $dh538.fg)('aifc_multiple_context')) {
                    // New mode: store as array, append if not already present
                    const existing = currentTargets[toAdd];
                    const targetList = existing ?? [];
                    // Avoid duplicates by checking if target with same id exists
                    // & filter out any targets with empty IDs to avoid stale targets
                    const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                    filtered.push(target);
                    setState({
                        contentTargets: {
                            ...currentTargets,
                            [toAdd]: filtered
                        }
                    });
                } else // Legacy behavior: single target
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: target
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId && (0, $dh538.fg)('aifc_multiple_context')) {
                        // If multiple-context mode with a specific targetId, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId
    }
});
const $3527ba50fc1c4fde$export$53bf948a400e8426 = (0, $9zUhf.createActionsHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9);
const $3527ba50fc1c4fde$export$9465f65715425f1b = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $3527ba50fc1c4fde$export$eea520981851a092 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $3527ba50fc1c4fde$export$debe3dc2612d2a8e = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $3527ba50fc1c4fde$export$376b2a7bf70dad8 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $3527ba50fc1c4fde$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext })=>{
    const actions = $3527ba50fc1c4fde$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $42omo.useCallback)(async (type, contentContext, activeTargetId)=>{
        const currentTargetId = getCurrentTargetId();
        // Only use activeTargetId when aifc_multiple_context is enabled
        const targetId = (0, $dh538.fg)('aifc_multiple_context') ? activeTargetId : undefined;
        const contentTarget = getTarget(contentContext, targetId);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody(type, selectedTargetId);
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    isViewMode: contentBody.isViewMode,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getEditorContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('page', contentContext, activeTargetId) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getWhiteboardContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('whiteboard', contentContext, activeTargetId) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('database', contentContext, activeTargetId) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $42omo.useCallback)(({ contentContext: contentContext, isFirstPrompt: isFirstPrompt })=>{
        if (contentContext === 'staging-area' && !isFirstPrompt && (0, $dh538.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $42omo.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $42omo.useCallback)((addCurrentPageAsContextUserPreference)=>{
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea
    ]);
    const getBrowserContext = (0, $42omo.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $c6GJD.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $42omo.useCallback)(async ()=>{
        if ((0, $dh538.fg)('jira-aifc-enable-preview-card-in-chat-v2')) {
            const isStagingArea = getIsStagingArea();
            if (!isStagingArea) {
                const jiraCreateContext = actions.getJiraCreateContext();
                if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
            }
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $3527ba50fc1c4fde$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
	 * If AIFC is not enabled, we default to the user's preference.
	 */ if (!isAifcEnabled) return userPreference;
    /**
	 * In the staging area, we always want to provide context if the source is the
	 * inline editor, or if the prompt is not the first in a new conversation.
	 */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
		 * On real content when AIFC is enabled, we only want to default to true
		 * if the source of the content is the inline editing experience. Otherwise,
		 * we want to respect the preference chosen by the user.
		 */ return sourceEligible || userPreference;
}
module.exports["useChatContextStoreActions"] = $3527ba50fc1c4fde$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $3527ba50fc1c4fde$export$9465f65715425f1b;
module.exports["useChatContextDatabaseContext"] = $3527ba50fc1c4fde$export$debe3dc2612d2a8e;
module.exports["useChatContextBrowserContext"] = $3527ba50fc1c4fde$export$376b2a7bf70dad8;
module.exports["useChatContextProvider"] = $3527ba50fc1c4fde$export$904052abb7b98535;

});

parcelRegister("6Vqkv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $irOoi = parcelRequire("irOoi");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $dh538 = parcelRequire("dh538");


var $aMqwg = parcelRequire("aMqwg");


var $16lEl = parcelRequire("16lEl");


var $ljUdP = parcelRequire("ljUdP");


var $flpNp = parcelRequire("flpNp");


var $9eLw5 = parcelRequire("9eLw5");


var $h26dv = parcelRequire("h26dv");


var $f2OFx = parcelRequire("f2OFx");


var $2Cfy4 = parcelRequire("2Cfy4");





var $8CAML = parcelRequire("8CAML");

const $ddc6cc090d64d6da$export$92f11cf4e802b166 = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $ddc6cc090d64d6da$export$91e35509133d1cc1 = (agentNode)=>({
        creator_type: agentNode.creatorType,
        creator: agentNode.creator?.id,
        description: agentNode.description,
        external_config_reference: agentNode.externalConfigReference,
        favourite: agentNode.isFavourite,
        id: $ddc6cc090d64d6da$export$92f11cf4e802b166(agentNode.id) ?? '',
        agentAri: agentNode.id,
        identity_account_id: agentNode.identityAccountId,
        name: agentNode.name,
        user_defined_conversation_starters: agentNode.conversationStarters,
        icon: agentNode.icon,
        // We need named_id here as the FE requires it for certain features
        named_id: $ddc6cc090d64d6da$export$92f11cf4e802b166(agentNode.id) ?? '',
        authoring_team: agentNode?.authoringTeam ? {
            id: agentNode.authoringTeam.id,
            profile_url: agentNode.authoringTeam.profileUrl,
            display_name: agentNode.authoringTeam.displayName,
            avatar_url: agentNode.authoringTeam.smallAvatarImageUrl
        } : null,
        is_verified: agentNode.isVerified
    });


const $824f750b126db2e8$export$cf57de7718965ae3 = {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: undefined,
    endCursor: undefined
};
const $824f750b126db2e8$var$transformAgentListToGqlResponse = (response)=>{
    try {
        // data can be null if the `abortController` is aborted
        const { edges: edges, pageInfo: pageInfo } = response?.data?.agentStudio_getAgents ?? {
            pageInfo: $824f750b126db2e8$export$cf57de7718965ae3
        };
        const agents = edges?.map((edge)=>(0, $ddc6cc090d64d6da$export$91e35509133d1cc1)(edge.node)).filter((agent)=>!!agent.id) ?? [];
        return {
            agents: agents,
            pageInfo: pageInfo
        };
    } catch  {
        return {
            agents: [],
            pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: undefined,
                endCursor: undefined
            }
        };
    }
};
const $824f750b126db2e8$var$agentStudioAssistantFragment = `
fragment conversationAssistantAgent_agentStudioAssistant on AgentStudioAssistant {
  id
  name
  description
  conversationStarters
  isFavourite
  creatorType
  identityAccountId
  externalConfigReference
  creator {
    id
  }
  icon
  authoringTeam {
    id
    profileUrl
    displayName
		smallAvatarImageUrl
  }
  isVerified
}
`;
const $824f750b126db2e8$export$44f796a68d9bc9f1 = async ({ cloudId: cloudId, count: count = 10, after: after, product: product, input: input, abortController: abortController, workspaceId: workspaceId })=>{
    (0, $fBMbo.di)((0, $8CAML.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput, $after: String, $product: String, $workspaceId: String) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
			after: $after
			product: $product
			workspaceId: $workspaceId
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...conversationAssistantAgent_agentStudioAssistant
				}
			}
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
		}
	}

	${$824f750b126db2e8$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        first: count,
        after: after,
        product: product,
        input: input,
        workspaceId: workspaceId
    };
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables,
        abortController: abortController
    });
    return $824f750b126db2e8$var$transformAgentListToGqlResponse(response);
};
const $824f750b126db2e8$export$fce04ce5e2fe57d3 = async ({ cloudId: cloudId, externalConfigReference: externalConfigReference })=>{
    (0, $fBMbo.di)((0, $8CAML.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgentByExternalConfigReference($cloudId: String!, $externalConfigReference: String!) {
		agentStudio_getByExternalReference(cloudId: $cloudId, externalReference: $externalConfigReference) @optIn(to: "AgentStudio") {
			...conversationAssistantAgent_agentStudioAssistant
		}
	}

	${$824f750b126db2e8$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        externalConfigReference: externalConfigReference
    };
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables
    });
    return (0, $ddc6cc090d64d6da$export$91e35509133d1cc1)(response.data.agentStudio_getByExternalReference);
};



var $iswAx = parcelRequire("iswAx");


var $1uFMJ = parcelRequire("1uFMJ");


var $4ul15 = parcelRequire("4ul15");


var $hT0Hx = parcelRequire("hT0Hx");

const $12593467a1d8dec1$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
    const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
    let overridenAgents = [];
    if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
            ...agent,
            is_default: index === defaultOverrideAgentsIndex
        }));
    else overridenAgents = agents;
    if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
    return overridenAgents;
};



var $cqFPV = parcelRequire("cqFPV");


var $cgtv4 = parcelRequire("cgtv4");

const $e2b97d183040b705$var$_default_1 = (0, $cgtv4.defineMessages)({
    defaultAgentName: {
        id: "ai-mate.agent-selector.default-agent-name",
        defaultMessage: "Chat"
    },
    defaultAgentDescription: {
        id: "ai-mate.agent-selector.default-agent-description",
        defaultMessage: "Get answers, generate new ideas, and accelerate everyday work."
    }
});
var $e2b97d183040b705$export$2e2bcd8739ae039 = $e2b97d183040b705$var$_default_1;


const $c0881cdb28f9c5e5$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
        if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
        else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
        else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
        else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
        return categorisedAgents;
    }, {
        public: [],
        private: [],
        system: []
    });
/**
 * @deprecated Please use `useAgentsPaginated...` hooks instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $c0881cdb28f9c5e5$var$agentsStore = (0, $1P1Tu.createStore)({
    initialState: {
        availableAgents: [],
        categorisedAgents: {
            private: [],
            public: [],
            system: []
        },
        agentsInitialized: false,
        agentsError: undefined
    },
    name: 'AgentsStore',
    actions: {
        setAgents: (availableAgents)=>({ setState: setState })=>{
                setState({
                    availableAgents: availableAgents,
                    categorisedAgents: $c0881cdb28f9c5e5$var$categoriseAgents(availableAgents)
                });
            },
        setAgentsInitialized: ()=>({ setState: setState })=>{
                setState({
                    agentsInitialized: true
                });
            },
        setAgentsError: (agentsError)=>({ setState: setState })=>{
                setState({
                    agentsError: agentsError
                });
            }
    }
});
/**
 * @deprecated Please use `useAgentsPaginated...` instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $c0881cdb28f9c5e5$var$useAgentsStore = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsStore);
const $c0881cdb28f9c5e5$export$f5b1109ecd7858c1 = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, experienceId: experienceId, product: product, siteId: siteId, touchpointSource: touchpointSource } })=>{
    // TODO remove `isRovoEnabled`
    const { isRovoEnabled: isRovoEnabled } = (0, $aMqwg.useRovoEntitlement)();
    const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, $hT0Hx.useAgentOverrider)();
    const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized, agentsError: agentsError }, { setAgents: setAgents, setAgentsInitialized: setAgentsInitialized, setAgentsError: setAgentsError }] = $c0881cdb28f9c5e5$var$useAgentsStore();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $4ul15.useAgentFavourites)({
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        }
    });
    const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
    const defaultAgent = (0, $42omo.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
        availableAgents
    ]);
    const nonDefaultAgents = (0, $42omo.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
        availableAgents
    ]);
    const nonDefaultFavouriteAgents = (0, $42omo.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
        nonDefaultAgents
    ]);
    const fetchAndStoreAvailableAgents = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchAgents'
        ],
        queryFn: async ()=>{
            try {
                experienceTracker.start({
                    id: (0, $16lEl.ExperienceName).FETCH_AGENTS,
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                });
                const agents = await assistanceService.getAgents();
                const transformedAgents = agents.map((agent)=>{
                    // Rename default agent to Chat, which is displayed in the UI
                    if (agent.is_default) {
                        agent.name = formatMessage((0, $e2b97d183040b705$export$2e2bcd8739ae039).defaultAgentName);
                        agent.description = formatMessage((0, $e2b97d183040b705$export$2e2bcd8739ae039).defaultAgentDescription);
                    }
                    return agent;
                });
                const overriddenAgents = (0, $12593467a1d8dec1$export$b873e2166b2a4c4f)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                setAgents(overriddenAgents);
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                });
                setAgentsInitialized();
            } catch (error) {
                //Filter out HIPAA errors from experience tracker https://product-fabric.atlassian.net/browse/ROVOFE-543
                if ((0, $cqFPV.isHipaaError)(error)) {
                    experienceTracker.succeed({
                        name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                if ((0, $ljUdP.isRateLimitedError)(error)) setAgentsError(error);
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS,
                    error: error
                });
                throw error;
            }
        },
        onError: onError,
        enabled: isRovoEnabled,
        refetchOnWindowFocus: false
    });
    const { deleteAgent: deleteAgent } = (0, $1uFMJ.useDeleteAgent)({
        onSuccess: ()=>{
            fetchAndStoreAvailableAgents.refetch();
        },
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        },
        onInit: (id)=>{
            setAgents(availableAgents.filter((agent)=>agent.id !== id));
        },
        onError: ()=>{
            setAgents(availableAgents);
        }
    });
    const setFavouriteAgent = (0, $42omo.useCallback)(async (id, isFavourite)=>{
        const updatedAgent = availableAgents.find((a)=>a.id === id);
        const setUpdatedAgent = (shouldBeFavourite)=>{
            if (updatedAgent) {
                updatedAgent.favourite = shouldBeFavourite;
                setAgents(availableAgents.map((a)=>{
                    // If the current agent's id matches the new agent's id, return the new agent.
                    // Otherwise, return the current agent.
                    return a.id === updatedAgent.id ? updatedAgent : a;
                }));
            }
        };
        //Optimistically update favourite value before we mutate
        setUpdatedAgent(isFavourite);
        //Pass callback to roll back optimistic update if mutation fails
        const errorCallback = {
            onError: ()=>{
                setUpdatedAgent(!isFavourite);
            }
        };
        if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        availableAgents,
        setAgents,
        favouriteAgent,
        unfavouriteAgent
    ]);
    /** This updates the agent on the client side only
   * Useful for updating the agent after a successful mutation
   */ const updateAgentLocally = (0, $42omo.useCallback)((agentId, updatedAgent)=>{
        const updatedAgents = availableAgents.map((agent)=>{
            if (agent.id === agentId) return {
                ...agent,
                ...updatedAgent
            };
            return agent;
        });
        setAgents(updatedAgents);
    }, [
        availableAgents,
        setAgents
    ]);
    return {
        availableAgents: availableAgents,
        favouritedAgents: favouritedAgents,
        categorisedAgents: categorisedAgents,
        fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        defaultAgent: defaultAgent,
        agentsInitialized: agentsInitialized,
        nonDefaultAgents: nonDefaultAgents,
        nonDefaultFavouriteAgents: nonDefaultFavouriteAgents,
        updateAgentLocally: updateAgentLocally,
        agentsError: agentsError
    };
});
const $c0881cdb28f9c5e5$var$agentsPaginatedStore = (0, $1P1Tu.createStore)({
    initialState: {
        /*
    Hash map which is the source of truth for agent data
    agent categories simply hold the agent ids to perform a lookup
    */ agentsMap: {},
        loadingCategories: new Set(),
        agentCategories: {
            ['all-agents']: {
                agentIds: [],
                pageInfo: (0, $824f750b126db2e8$export$cf57de7718965ae3),
                abortController: new AbortController()
            },
            ['starred-agents']: {
                agentIds: [],
                pageInfo: (0, $824f750b126db2e8$export$cf57de7718965ae3),
                abortController: new AbortController()
            },
            ['my-agents']: {
                agentIds: [],
                pageInfo: (0, $824f750b126db2e8$export$cf57de7718965ae3),
                abortController: new AbortController()
            },
            ['templates']: {
                agentIds: [],
                pageInfo: (0, $824f750b126db2e8$export$cf57de7718965ae3),
                abortController: new AbortController()
            },
            ['verified-agents']: {
                agentIds: [],
                pageInfo: (0, $824f750b126db2e8$export$cf57de7718965ae3),
                abortController: new AbortController()
            }
        }
    },
    name: 'AgentsPaginatedStore',
    actions: {
        /**
     * This action populates a specific category with backend data
     * it will store the ids in `agentCategories` and the agents in `agentsMap`
     */ populateAgentCategories: ({ agentsList: agentsList, pageInfo: pageInfo, category: category = 'all-agents' })=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                updatedAgentCategories[category].pageInfo = pageInfo;
                if (!agentsList.length) updatedAgentCategories[category].agentIds = [];
                else agentsList.forEach((agent)=>{
                    updatedAgentsMap[agent.id] = agent;
                    updatedAgentCategories[category].agentIds.push(agent.id);
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        setAgentCategoriesByCategory: ({ categoryName: categoryName, agentCategoryData: agentCategoryData })=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: agentCategoryData
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        setCategoryError: (categoryName, agentsError)=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: {
                        ...agentCategories[categoryName],
                        agentsError: agentsError
                    }
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        getAgentCategoriesByCategory: (category)=>({ getState: getState })=>{
                const state = getState();
                const { agentCategories: agentCategories } = state;
                return agentCategories[category];
            },
        removeAgent: (id)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const catsImpacted = new Set();
                let agentToReturn;
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                if (agentsMap[id]) {
                    agentToReturn = agentsMap[id];
                    delete updatedAgentsMap[id];
                }
                Object.keys(agentCategories).forEach((category)=>{
                    if (updatedAgentCategories[category]?.agentIds.includes(id)) {
                        updatedAgentCategories[category].agentIds = updatedAgentCategories[category].agentIds.filter((agentId)=>agentId !== id);
                        catsImpacted.add(category);
                    }
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
                return {
                    agent: agentToReturn,
                    categories: Array.from(catsImpacted)
                };
            },
        addAgent: (agent, categories = [
            'all-agents'
        ])=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                categories.forEach((category)=>{
                    updatedAgentCategories?.[category]?.agentIds.push(agent.id);
                });
                updatedAgentsMap[agent.id] = agent;
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        updateAgent: (id, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const prevData = agentsMap[id] ?? {};
                const updatedData = {
                    ...prevData,
                    ...data
                };
                updatedAgentsMap[id] = updatedData;
                setState({
                    agentsMap: updatedAgentsMap
                });
                return updatedData;
            },
        setCategoryLoading: (category, loading)=>({ setState: setState, getState: getState })=>{
                const { loadingCategories: loadingCategories } = getState();
                const updatedLoadingCategories = new Set(loadingCategories);
                if (loading) updatedLoadingCategories.add(category);
                else updatedLoadingCategories.delete(category);
                setState({
                    loadingCategories: updatedLoadingCategories
                });
            },
        abortCategoryFetch: (category)=>({ getState: getState })=>{
                const { agentCategories: agentCategories } = getState();
                agentCategories[category].abortController.abort();
                agentCategories[category].abortController = new AbortController();
            },
        getCachedAgentByExternalConfigReference: (externalConfigReference)=>({ getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                return Object.values(agentsMap).find((agent)=>agent.external_config_reference === externalConfigReference);
            }
    }
});
const $c0881cdb28f9c5e5$export$1553678862324ff0 = (0, $9zUhf.createActionsHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore);
const $c0881cdb28f9c5e5$export$cea603150faaa56f = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    // TODO https://product-fabric.atlassian.net/browse/RAGE-618
    // change `{ agentId }` to `agentId`
    selector: (state, agentId)=>({
            agent: state.agentsMap[agentId],
            doesAgentExist: Boolean(state.agentsMap[agentId])
        })
});
const $c0881cdb28f9c5e5$export$44c2e95a7a8b47c9 = (0, $h26dv.createHookWithAssistanceService)(({ agentId: agentId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$44c2e95a7a8b47c9, $c0881cdb28f9c5e5$export$cea603150faaa56f, $c0881cdb28f9c5e5$export$1553678862324ff0);
    const [{ agent: agent, doesAgentExist: doesAgentExist }] = $c0881cdb28f9c5e5$export$cea603150faaa56f(agentId ?? '');
    const { updateAgent: updateAgent } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const { error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'agentHydration',
            agentId ?? ''
        ],
        queryFn: async ()=>{
            if (!agentId) // this throw won't happen because the `enabled` field below
            throw new Error('Agent ID is required');
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA,
                id: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA
            });
            const response = await assistanceService.getAgentDetails(agentId);
            return response;
        },
        enabled: Boolean(agentId) && !doesAgentExist,
        onSuccess: (data)=>{
            if (!agentId) return;
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA
            });
            updateAgent(agentId ?? '', data);
        },
        onError: (error)=>{
            if (!agentId) return;
            const is404Error = error.errorAttributes.statusCode === 404;
            const is403Error = error.errorAttributes.statusCode === 403 && (0, $dh538.fg)('convo-ai-enable-agents-use-permission');
            if (!(is404Error || is403Error)) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    if (!agentId) return {
        agent: undefined,
        error: undefined
    };
    return {
        agent: agent,
        error: error ?? undefined
    };
});
const $c0881cdb28f9c5e5$export$eae59c91509947e4 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    const environment = (0, $irOoi.useRelayEnvironment)();
    const removedAgentCache = (0, $42omo.useRef)({
        categories: [],
        agent: undefined
    });
    const { removeAgent: removeAgent, addAgent: addAgent, updateAgent: updateAgent } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $4ul15.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    // Note: Experience Tracker events implemented in useDeleteAgent
    const { deleteAgent: deleteAgent } = (0, $1uFMJ.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceInjectedParams,
        onInit: (id)=>{
            const { categories: categories, agent: agent } = removeAgent(id);
            removedAgentCache.current = {
                categories: categories,
                agent: agent
            };
        },
        onError: ()=>{
            if (removedAgentCache.current.agent) addAgent(removedAgentCache.current.agent, removedAgentCache.current.categories);
        }
    });
    // Note: Experience Tracker events implemented in useAgentFavourites
    const setFavouriteAgent = (0, $42omo.useCallback)(async (id, favourite, agentAri)=>{
        // Optimistic update
        updateAgent(id, {
            favourite: favourite
        });
        const localRelayUpdate = async (isFavourite)=>{
            if (agentAri) (0, $irOoi.commitLocalUpdate)(environment, (store)=>{
                const id = (0, $f2OFx.default)({
                    id: agentAri
                }, 'AgentStudioAssistant');
                if (!id) return;
                const agentRecord = store.get(id);
                if (agentRecord) agentRecord.setValue(isFavourite, 'isFavourite');
                const root = store.getRoot();
                const connection = (0, $irOoi.ConnectionHandler).getConnection(root, 'paginatedAgentsList_agentStudio_getAgents', {
                    cloudId: assistanceServiceInjectedParams.siteId,
                    input: {
                        onlyFavouriteAgents: true
                    },
                    product: assistanceServiceInjectedParams.product
                });
                const agentDataID = agentRecord?.getDataID();
                if (!connection || !agentDataID || !agentRecord) return;
                if (isFavourite) {
                    const edge = (0, $irOoi.ConnectionHandler).createEdge(store, connection, agentRecord, 'AgentStudioAgentEdge');
                    (0, $irOoi.ConnectionHandler).insertEdgeAfter(connection, edge);
                } else (0, $irOoi.ConnectionHandler).deleteNode(connection, agentDataID);
            });
        };
        localRelayUpdate(favourite);
        const errorCallback = {
            onError: ()=>{
                // Reverse optimistic update
                updateAgent(id, {
                    favourite: !favourite
                });
                localRelayUpdate(!favourite);
            }
        };
        if (favourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        assistanceServiceInjectedParams.product,
        assistanceServiceInjectedParams.siteId,
        environment,
        favouriteAgent,
        unfavouriteAgent,
        updateAgent
    ]);
    /**
   * Function that updates the verified status of an agent.
   * This can be removed once the dropdown has converted over to relay.
   */ const setVerifiedAgent = (0, $42omo.useCallback)((id, isVerified)=>{
        updateAgent(id, {
            is_verified: isVerified
        });
    }, [
        updateAgent
    ]);
    // Local cache update function for optimistic delete
    // This only handles cache updates, not API calls or analytics
    const deleteAgentLocally = (0, $42omo.useCallback)((id)=>{
        // Optimistically remove from cache
        const { categories: categories, agent: agent } = removeAgent(id);
        // Return restore function for error handling
        return {
            restore: ()=>{
                if (agent) addAgent(agent, categories);
            }
        };
    }, [
        removeAgent,
        addAgent
    ]);
    return {
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        setVerifiedAgent: setVerifiedAgent,
        deleteAgentLocally: deleteAgentLocally
    };
});
const $c0881cdb28f9c5e5$export$cc3deb815b1c179b = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    selector: (state, category)=>({
            agentsByCategory: state.agentCategories[category].agentIds.map((agentId)=>state.agentsMap[agentId]),
            isCategoryInitialized: state.agentCategories[category].pageInfo.startCursor !== undefined && state.agentCategories[category].pageInfo.endCursor !== undefined,
            isCategoryLoading: state.loadingCategories.has(category),
            isCategoryEmpty: state.agentCategories[category].agentIds.length === 0,
            hasNextPage: state.agentCategories[category].pageInfo.hasNextPage,
            nextPageCursor: state.agentCategories[category].pageInfo.endCursor,
            agentsError: state.agentCategories[category].agentsError
        })
});
const $c0881cdb28f9c5e5$export$e6997ec35c535c54 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $fBMbo.di)((0, $hT0Hx.useAgentOverrider), $c0881cdb28f9c5e5$export$1553678862324ff0);
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $hT0Hx.useAgentOverrider)();
    const { addAgent: addAgent, populateAgentCategories: populateAgentCategories } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const fetchOverriddenAgentsAndPopulateStoreQuery = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? ''
        ],
        queryFn: async ()=>{
            const agentIdsToFetchSet = new Set();
            if (agentDefaultIdOverride) agentIdsToFetchSet.add(agentDefaultIdOverride);
            if (agentIdFiltersOverride?.length) agentIdFiltersOverride.forEach((agentId)=>{
                agentIdsToFetchSet.add(agentId);
            });
            if (agentIdsToFetchSet.size === 0) return;
            const agentIdsToFetch = Array.from(agentIdsToFetchSet);
            populateAgentCategories({
                category: 'all-agents',
                agentsList: [],
                pageInfo: (0, $824f750b126db2e8$export$cf57de7718965ae3)
            });
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES,
                id: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
            const agents = await Promise.all(agentIdsToFetch.map(async (agentId)=>{
                return await assistanceService.getAgentDetails(agentId);
            }));
            // then add the agents into "All agents" category
            agents.forEach((agent)=>{
                addAgent(agent, [
                    'all-agents'
                ]);
            });
            return agentIdsToFetch;
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: false
    });
    return {
        fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStoreQuery.refetch
    };
});
const $c0881cdb28f9c5e5$export$94c2040c41639ede = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$1553678862324ff0, (0, $hT0Hx.useAgentOverrider), $c0881cdb28f9c5e5$export$e6997ec35c535c54);
    const { experienceTracker: experienceTracker, siteId: siteId, product: product, headers: assistanceServiceHeaders } = assistanceServiceInjectedParams;
    const actions = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const { setCategoryLoading: setCategoryLoading, setCategoryError: setCategoryError, populateAgentCategories: populateAgentCategories, getAgentCategoriesByCategory: getAgentCategoriesByCategory, setAgentCategoriesByCategory: setAgentCategoriesByCategory } = actions;
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $hT0Hx.useAgentOverrider)();
    const { fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStore } = $c0881cdb28f9c5e5$export$e6997ec35c535c54({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const fetchAgentsByCategory = (0, $42omo.useCallback)(async ({ category: category = 'all-agents', after: after, query: query })=>{
        // if there are any overrides, cancel the normal fetchByCategory and instead fetch the overridden agents
        if (agentDefaultIdOverride || agentIdFiltersOverride?.length) return await fetchOverriddenAgentsAndPopulateStore() ?? [];
        const dataBeforeFetch = getAgentCategoriesByCategory(category);
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED,
            id: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
        });
        let queryInput = {};
        switch(category){
            case 'starred-agents':
                queryInput.onlyFavouriteAgents = true;
                break;
            case 'my-agents':
                queryInput.onlyMyAgents = true;
                break;
            case 'templates':
                queryInput.onlyTemplateAgents = true;
                break;
            case 'verified-agents':
                queryInput.onlyVerifiedAgents = true;
                break;
        }
        if (query) queryInput.name = query;
        // for rolling back data in case of abort/failure
        const resetData = ()=>{
            setAgentCategoriesByCategory({
                categoryName: category,
                agentCategoryData: dataBeforeFetch
            });
            return dataBeforeFetch.agentIds;
        };
        // No after means we're requesting the first page so the category data is reset
        if (!after) populateAgentCategories({
            category: category,
            agentsList: [],
            pageInfo: (0, $824f750b126db2e8$export$cf57de7718965ae3)
        });
        setCategoryLoading(category, true);
        setCategoryError(category, undefined);
        const headers = new Headers(assistanceServiceHeaders);
        const maybeWorkspaceId = headers.get('x-workspace-id');
        try {
            const response = await (0, $824f750b126db2e8$export$44f796a68d9bc9f1)({
                after: after ?? undefined,
                cloudId: siteId,
                count: 10,
                input: Object.keys(queryInput).length > 0 ? queryInput : undefined,
                product: product,
                abortController: getAgentCategoriesByCategory(category).abortController,
                workspaceId: maybeWorkspaceId
            });
            setCategoryLoading(category, false);
            if (getAgentCategoriesByCategory(category).abortController.signal?.aborted) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return resetData();
            }
            if (response) {
                populateAgentCategories({
                    category: category,
                    agentsList: response.agents,
                    pageInfo: response.pageInfo
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
                });
            }
            return response?.agents.map((agent)=>agent.id);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            const prevAgentIds = resetData();
            setCategoryError(category, error);
            setCategoryLoading(category, false);
            if (error instanceof (0, $flpNp.ApiError)) onError?.(error);
            return prevAgentIds;
        }
    }, [
        agentDefaultIdOverride,
        agentIdFiltersOverride?.length,
        getAgentCategoriesByCategory,
        experienceTracker,
        setCategoryLoading,
        setCategoryError,
        assistanceServiceHeaders,
        fetchOverriddenAgentsAndPopulateStore,
        setAgentCategoriesByCategory,
        populateAgentCategories,
        siteId,
        product,
        onError
    ]);
    return {
        ...actions,
        fetchAgentsByCategory: fetchAgentsByCategory
    };
});
const $c0881cdb28f9c5e5$export$65c6565d33cf8f4f = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    selector: (state)=>state.agentsMap
});
const $c0881cdb28f9c5e5$export$631401679afcb10f = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, limit: limit = 3, pageUrl: pageUrl })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$65c6565d33cf8f4f);
    const { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } = assistanceServiceInjectedParams;
    const [agentsMap, { updateAgent: updateAgent }] = $c0881cdb28f9c5e5$export$65c6565d33cf8f4f();
    const { isFetching: isFetching, data: data } = (0, $9eLw5.useQuery)({
        queryKey: [
            'recommendedAgents',
            limit,
            pageUrl ?? ''
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS,
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
            });
            const response = await assistanceService.getRecommendedAgents({
                limit: limit,
                pageUrl: pageUrl
            });
            // store the agents in the paginated store for optimistic updates etc
            // not adding them to specific category in local cache on purpose
            response.agents.forEach((agent)=>{
                updateAgent(agent.id, agent);
            });
            return response;
        },
        enabled: Boolean(siteId),
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
            });
        },
        onError: (error)=>{
            if ((0, $cqFPV.isHipaaError)(error)) {
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    return {
        isFetching: isFetching,
        recommendedAgents: data?.agents.map((agent)=>agentsMap[agent.id]).filter(Boolean) ?? [],
        recommendationKey: data?.metadata?.recommendationKey
    };
});
const $c0881cdb28f9c5e5$export$71d3696dcc60eb2d = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$1553678862324ff0, (0, $824f750b126db2e8$export$fce04ce5e2fe57d3));
    const { updateAgent: updateAgent, getCachedAgentByExternalConfigReference: getCachedAgentByExternalConfigReference } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const getAndStoreAgentByExternalConfigReference = (0, $42omo.useCallback)(async ({ externalConfigReference: externalConfigReference })=>{
        const cachedAgent = getCachedAgentByExternalConfigReference(externalConfigReference);
        if (cachedAgent) return cachedAgent;
        try {
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            const agentData = await (0, $824f750b126db2e8$export$fce04ce5e2fe57d3)({
                cloudId: siteId,
                externalConfigReference: externalConfigReference
            });
            // cache the data
            updateAgent(agentData.id, agentData);
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            return agentData;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            return undefined;
        }
    }, [
        getCachedAgentByExternalConfigReference,
        experienceTracker,
        siteId,
        updateAgent
    ]);
    return {
        getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference
    };
});
const $c0881cdb28f9c5e5$export$eee66751ca85dbf7 = (param)=>{
    return $c0881cdb28f9c5e5$export$f5b1109ecd7858c1(param);
};
const $c0881cdb28f9c5e5$export$6553fa633373a34 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { product: product, experienceId: experienceId, headers: headers, touchpointSource: touchpointSource, siteId: siteId }, filter: filter })=>{
    const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $c0881cdb28f9c5e5$export$eee66751ca85dbf7({
        assistanceServiceParams: {
            product: product,
            experienceId: experienceId,
            headers: headers,
            touchpointSource: touchpointSource,
            siteId: siteId
        }
    });
    const defaultAgents = (0, $iswAx.getSuggestedOotbAgents)({
        availableAgents: availableAgents,
        product: product
    });
    const defaultAgentsOutsideUserFavourites = defaultAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.id === defaultAgent.id));
    const favouritedAgentsWithDefault = [
        ...favouritedAgents,
        ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
    ];
    return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
});
module.exports["useAgentsPaginatedByAgentId"] = $c0881cdb28f9c5e5$export$44c2e95a7a8b47c9;
module.exports["useAgentsPaginatedActionsWithOptimistic"] = $c0881cdb28f9c5e5$export$eae59c91509947e4;
module.exports["usePaginatedAgentsByCategory"] = $c0881cdb28f9c5e5$export$cc3deb815b1c179b;
module.exports["usePaginatedAgentsActions"] = $c0881cdb28f9c5e5$export$94c2040c41639ede;
module.exports["useRecommendedAgents"] = $c0881cdb28f9c5e5$export$631401679afcb10f;
module.exports["usePaginatedAgentByConfigReference"] = $c0881cdb28f9c5e5$export$71d3696dcc60eb2d;
module.exports["useAgentsList"] = $c0881cdb28f9c5e5$export$6553fa633373a34;

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("9eLw5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $flpNp = parcelRequire("flpNp");

const $2c362c1c58e43242$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $2c362c1c58e43242$var$selector = (0, $cclHy.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $2c362c1c58e43242$var$useCacheEntry = (0, $9zUhf.createHook)($2c362c1c58e43242$var$store, {
    selector: $2c362c1c58e43242$var$selector
});
const $2c362c1c58e43242$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $42omo.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $2c362c1c58e43242$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $fFa3V.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData
    };
};
module.exports["useQuery"] = $2c362c1c58e43242$export$dd0a697e1782aedd;

});

parcelRegister("2Cfy4", function(module, exports) {
const $0009c874b00d4f72$export$73b400613798970e = 'rovo-agents-fe';
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $0009c874b00d4f72$export$73b400613798970e;

});

parcelRegister("8CAML", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $ece6631c27d5e331$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $ece6631c27d5e331$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $ece6631c27d5e331$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $ece6631c27d5e331$export$ba203f24e0131ba7) throw err;
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') return {
            data: null,
            errors: undefined
        };
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $8Igpw.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $ece6631c27d5e331$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $ece6631c27d5e331$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $ece6631c27d5e331$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $ece6631c27d5e331$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $ece6631c27d5e331$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $ece6631c27d5e331$export$ba203f24e0131ba7;

});

parcelRegister("iswAx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");


var $9EfFC = parcelRequire("9EfFC");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $9uTsJ = parcelRequire("9uTsJ");


var $hezkK = parcelRequire("hezkK");


var $kpYGL = parcelRequire("kpYGL");


var $1yaYZ = parcelRequire("1yaYZ");


var $9eLw5 = parcelRequire("9eLw5");


var $26nu6 = parcelRequire("26nu6");


var $cqFPV = parcelRequire("cqFPV");


var $fQF1W = parcelRequire("fQF1W");


var $eOn3v = parcelRequire("eOn3v");


var $cgtv4 = parcelRequire("cgtv4");

const $b55ef878efda143d$var$_default_1 = (0, $cgtv4.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $b55ef878efda143d$export$2e2bcd8739ae039 = $b55ef878efda143d$var$_default_1;


const $baa53903be441878$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $baa53903be441878$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $baa53903be441878$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $26nu6.isSystemAgent)(agent) || (0, $26nu6.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        testId: "atlassian-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: "Atlassian"
            })
        ]
    });
    if ((0, $26nu6.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            testId: "atlassian-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: authoringTeam.profile_url,
                target: "_blank",
                onClick: onClick,
                children: authoringTeam.display_name
            })
        });
        const aaid = agent.creator ? $baa53903be441878$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)($baa53903be441878$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $dh538.fg)('rovo_agent_support_a2a_avatar') ? (0, $hezkK.isForgeAgentByCreatorType)(agent.creator_type) : (0, $26nu6.isForgeAgent)(agent)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: agent.creator
    });
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $baa53903be441878$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $fBMbo.di)($baa53903be441878$export$5d980898591175e);
    const { profile: profile, client: client } = $baa53903be441878$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { atlasURL: atlasURL } = (0, $fQF1W.useAtlasURL)(siteId);
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $b55ef878efda143d$export$2e2bcd8739ae039).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: (0, $dh538.fg)('csmai_skeleton_border_refactor') ? "var(--ds-radius-small, 4px)" : 3
    });
    if (simplified) {
        const profileUrl = atlasURL(`/people/${userId}`);
        return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__ai-mate') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick,
            children: fullName
        }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, $l998X.jsx)("a", {
            href: profileUrl,
            target: "_blank",
            onClick: onClick,
            children: fullName
        });
    }
    return profileCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9uTsJ.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
function $baa53903be441878$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $eOn3v.useProfileClient)();
    const profile = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $1yaYZ.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $baa53903be441878$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $baa53903be441878$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources?.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $baa53903be441878$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $cqFPV.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $baa53903be441878$export$3761e66a04602cbd;
module.exports["getARIFromAAID"] = $baa53903be441878$export$acf3e1bcf222b00d;
module.exports["AgentCreatedBy"] = $baa53903be441878$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $baa53903be441878$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $baa53903be441878$export$a6e36c224ec3c0cb;
module.exports["getSuggestedOotbAgents"] = $baa53903be441878$export$6d876204c5d593ac;

});

parcelRegister("26nu6", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $04c28723649a2305$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $04c28723649a2305$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $04c28723649a2305$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $dh538.fg)('rovo_agent_support_a2a_avatar');
const $04c28723649a2305$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $04c28723649a2305$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $04c28723649a2305$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents'
};
module.exports["isSystemAgent"] = $04c28723649a2305$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $04c28723649a2305$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $04c28723649a2305$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $04c28723649a2305$export$7091e3bee2adaacb;

});

parcelRegister("cqFPV", function(module, exports) {
const $570a782ebb8f75e0$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $570a782ebb8f75e0$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $570a782ebb8f75e0$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $570a782ebb8f75e0$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $570a782ebb8f75e0$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE;
const $570a782ebb8f75e0$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$HIPAA_ERROR_CODE;
const $570a782ebb8f75e0$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $570a782ebb8f75e0$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $570a782ebb8f75e0$export$804d9ee5f4cc40a8;
module.exports["isCreateOrEditAgentAUPError"] = $570a782ebb8f75e0$export$a08ace1426fa4a9e;
module.exports["isHipaaError"] = $570a782ebb8f75e0$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $570a782ebb8f75e0$export$429080cfef3412f2;

});

parcelRegister("fQF1W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $827Ne = parcelRequire("827Ne");


var $dYtRL = parcelRequire("dYtRL");

const $2a6bb271c0fd2ecb$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $dYtRL.useTenantDataController)(siteId);
    const atlasURL = (0, $42omo.useCallback)((path)=>(0, $827Ne.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $2a6bb271c0fd2ecb$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202;

});

parcelRegister("827Ne", function(module, exports) {

var $6FQwA = parcelRequire("6FQwA");


var $bhcGS = parcelRequire("bhcGS");

const $5ae4133df3384b49$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $5ae4133df3384b49$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $5ae4133df3384b49$export$5105758c0e772381 = ()=>{
    return (0, $bhcGS.isStaging)() ? $5ae4133df3384b49$var$ATLAS_STAGING_URL : $5ae4133df3384b49$var$ATLAS_PROD_URL;
};
const $5ae4133df3384b49$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$5ae4133df3384b49$export$5105758c0e772381()}/o/${orgId}` : $5ae4133df3384b49$export$5105758c0e772381();
    return (0, $6FQwA.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $5ae4133df3384b49$export$5105758c0e772381;
module.exports["getAtlasURL"] = $5ae4133df3384b49$export$bfee0f88bf621ad3;

});

parcelRegister("6FQwA", function(module, exports) {
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt'
];


const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $0075612de7c1f282$export$5a550907ffbc9119}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $0075612de7c1f282$export$5a550907ffbc9119), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $0075612de7c1f282$export$5a550907ffbc9119))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $0075612de7c1f282$export$3cd6b610e7ede579).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $fba4647064c9da0b$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $fba4647064c9da0b$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $fba4647064c9da0b$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $fba4647064c9da0b$export$eddc20a009406015;

});

parcelRegister("bhcGS", function(module, exports) {
const $f2c917fe02396491$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $f2c917fe02396491$export$23da1d24a38b0bde;

});

parcelRegister("dYtRL", function(module, exports) {

var $fBMbo = parcelRequire("fBMbo");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $9eLw5 = parcelRequire("9eLw5");


var $hGGLc = parcelRequire("hGGLc");

const $63d59501eb65c4db$export$b863fec6791eae25 = (siteId)=>{
    (0, $fBMbo.di)((0, $9eLw5.useQuery));
    const experience = (0, $hUyPY.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hGGLc.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};
module.exports["useTenantDataController"] = $63d59501eb65c4db$export$b863fec6791eae25;

});

parcelRegister("hGGLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8CAML = parcelRequire("8CAML");

const $0fc4c72c92b990ea$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $0fc4c72c92b990ea$var$cache = new Map();
const $0fc4c72c92b990ea$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    // If AIFC is enabled, use the new caching
    if ((0, $dh538.fg)('aifc_create_enabled')) {
        // Check if we already have a pending promise or cached result
        if ($0fc4c72c92b990ea$var$cache.has(cloudId)) return $0fc4c72c92b990ea$var$cache.get(cloudId);
        const response = await (0, $8CAML.performGqlFetch)({
            gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
            variables: {
                cloudIds: [
                    cloudId
                ]
            }
        });
        const result = response.data?.tenantContexts?.[0];
        if (result) // Store the promise in the cache
        $0fc4c72c92b990ea$var$cache.set(cloudId, result);
        return result;
    }
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
module.exports["getCloudUrlFromId"] = $0fc4c72c92b990ea$export$d4ace54df9bd6bb1;

});

parcelRegister("eOn3v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $fHxn4 = parcelRequire("fHxn4");

const $1bde4828e2efe4cf$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $1bde4828e2efe4cf$var$client;
const $1bde4828e2efe4cf$export$d43dc22a8337ee9f = ()=>{
    (0, $fBMbo.di)((0, $fHxn4.default));
    const profileClient = (0, $42omo.useMemo)(()=>{
        if (!$1bde4828e2efe4cf$var$client) // To support di
        $1bde4828e2efe4cf$var$client = new (0, $fHxn4.default)({
            url: $1bde4828e2efe4cf$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $1bde4828e2efe4cf$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $1bde4828e2efe4cf$export$d43dc22a8337ee9f;

});

parcelRegister("1uFMJ", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $29BPs = parcelRequire("29BPs");


var $h26dv = parcelRequire("h26dv");


var $2Cfy4 = parcelRequire("2Cfy4");

const $4188851fb0c3debc$export$89877d4f8d8790ca = (0, $h26dv.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).DELETE_AGENT,
                name: (0, $16lEl.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).DELETE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});
module.exports["useDeleteAgent"] = $4188851fb0c3debc$export$89877d4f8d8790ca;

});

parcelRegister("4ul15", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $29BPs = parcelRequire("29BPs");


var $h26dv = parcelRequire("h26dv");


var $2Cfy4 = parcelRequire("2Cfy4");

const $d9bcfe62b373548d$export$5c4c46b1f93a6e69 = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).FAVOURITE_AGENT,
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});
module.exports["useAgentFavourites"] = $d9bcfe62b373548d$export$5c4c46b1f93a6e69;

});

parcelRegister("hT0Hx", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6570846fafa2bfa7$export$ccc6603eb027f48b = /*#__PURE__*/ (0, $42omo.createContext)({});
const $6570846fafa2bfa7$export$7b61e11d4e81ba17 = ()=>(0, $42omo.useContext)($6570846fafa2bfa7$export$ccc6603eb027f48b);
const $6570846fafa2bfa7$export$aa582af5b4b72bb2 = $6570846fafa2bfa7$export$ccc6603eb027f48b.Provider;
const $6570846fafa2bfa7$export$6aab84dc399ad753 = (config)=>({
        agentDefaultIdOverride: config?.defaultAgentId,
        agentIdFiltersOverride: config?.filter
    });
module.exports["useAgentOverrider"] = $6570846fafa2bfa7$export$7b61e11d4e81ba17;
module.exports["AgentOverriderProvider"] = $6570846fafa2bfa7$export$aa582af5b4b72bb2;
module.exports["createAgentsConfig"] = $6570846fafa2bfa7$export$6aab84dc399ad753;

});

parcelRegister("6UNNU", function(module, exports) {
/* ThinkingIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

/* EllipsesAnimation.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $32fc58aca0fb1b9e$var$animation = null;
const $32fc58aca0fb1b9e$var$animation1 = null;
const $32fc58aca0fb1b9e$var$animation2 = null;
const $32fc58aca0fb1b9e$var$dot1 = null;
const $32fc58aca0fb1b9e$var$dot2 = null;
const $32fc58aca0fb1b9e$var$dot3 = null;
const $32fc58aca0fb1b9e$var$animatedOpacity = null;
const $32fc58aca0fb1b9e$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v1gpk",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v18gg",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44voqx9",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
                fill: "#FCA700"
            })
        ]
    });
};


/* LazyAnimatedRovoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 






const $d19178c9b9dc2956$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("eOMI9")));
const $d19178c9b9dc2956$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($d19178c9b9dc2956$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});


const $68998c8ef6b7e73e$var$styles = {
    root: "_4t3i1tcg _1e0c1txw _2lx2vrvc _1bah1e5h _1n261g80 _4cvr1h6o",
    iconContainer: "_zulpu2gc _2hwxv77o _1e0c1txw _4cvr1h6o",
    text: "_11c8fhey _16jlkb7n _1o9zkb7n _i0dlf1ug _syazi7uo _1nmz1hna",
    ellipsesContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $68998c8ef6b7e73e$var$getIcon = (icon)=>{
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(icon)) return icon;
    else if (icon) {
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d19178c9b9dc2956$export$7ea4e54699cd5224), {
            alt: "Rovo",
            testId: "rovo-loading-animation",
            width: "24px",
            height: "24px"
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
            label: "",
            shouldUseHexLogo: true,
            size: "small"
        });
    }
    return null;
};
const $68998c8ef6b7e73e$export$cc468b3595726b51 = ({ title: title, isAnimated: isAnimated = true, icon: icon = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $68998c8ef6b7e73e$var$styles.root,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $68998c8ef6b7e73e$var$styles.iconContainer,
                children: [
                    $68998c8ef6b7e73e$var$getIcon(icon),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $68998c8ef6b7e73e$var$styles.text,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $68998c8ef6b7e73e$var$styles.ellipsesContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $32fc58aca0fb1b9e$export$c0e6915bcce7d1d0), {
                    isAnimated: isAnimated
                })
            })
        ]
    });
};
module.exports["RovoThinkingIndicator"] = $68998c8ef6b7e73e$export$cc468b3595726b51;

});

parcelRegister("eOMI9", function(module, exports) {

let $ac9b85351e52bf24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac9b85351e52bf24$var$load("2MGzj").then(()=>parcelRequire('boWof'));

});

parcelRegister("hAuc5", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");

function $fe15ff31308e86c4$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $fe15ff31308e86c4$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $fe15ff31308e86c4$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-expect-error
                if (tok.pmAttrs) // @ts-expect-error
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                // When token.pmAttrs is missing it means it's an external image.
                // @ts-expect-error
                if (token.pmAttrs) // @ts-expect-error
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        placeholder: {
            node: 'placeholder',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        }
    });


const $0773845a48a88423$var$captionOpen = 'caption_open';
const $0773845a48a88423$var$paragraphOpen = 'paragraph_open';
const $0773845a48a88423$var$paragraphClose = 'paragraph_close';
function $0773845a48a88423$export$eee367902819022(index, tokens) {
    // make sure we have an opening and closing paragraph token
    if (tokens[index]?.type !== $0773845a48a88423$var$paragraphOpen && tokens[index + 2]?.type !== $0773845a48a88423$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    tokens[index + 2]?.type === $0773845a48a88423$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $0773845a48a88423$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            const isWithinCaption = acc[acc.length - 1]?.type === $0773845a48a88423$var$captionOpen;
            if (type === $0773845a48a88423$var$paragraphOpen && isWithinCaption) /**
				 * paragraph_open and paragraph_close tokens get automatically added by markdown-it
				 * around text content. caption nodes do not allow paragraph nodes as children
				 * so we need to prevent these tokens from being added to the acc
				 */ $0773845a48a88423$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}


function $e92fa7dc1daa52ee$export$2e2bcd8739ae039(md) {
    md.inline.ruler.before('text', 'citation', function(state, silent) {
        const str = state.src.slice(state.pos);
        /**
		 * Matches the following:
		 * [^00^]
		 */ // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const citationRegexp = /^\[\^[^\^]+\^]/;
        const match = citationRegexp.exec(str);
        if (!match) return false;
        if (silent) return true;
        // Just skip citation from parsing and don't render them in the output.
        state.pos += match[0].length;
        return true;
    });
}


function $6d1436b1813e587d$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}


function $bb6e978431b17277$export$e717b161ec14d433(tokens) {
    const openTokenIndexMap = new Map();
    const toRemove = new Set();
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // This attribute is set earlier in this file (customElementToken.attrPush(['isCustomBlock', 'true']))
        // So we can identify tokens added by this rule
        if (token.attrGet('isCustomBlock') === 'true') {
            // We split by the last underscore
            const type = token.type.substring(0, token.type.lastIndexOf('_'));
            const prevIndex = openTokenIndexMap.get(type);
            // Only check for removal if type exists
            if (type && token.nesting === 1) {
                if (prevIndex !== undefined) toRemove.add(prevIndex);
                openTokenIndexMap.set(type, i);
            } else if (type && token.nesting === -1) {
                if (prevIndex !== undefined) // If previous open token found, then we've found a match and we can close it
                openTokenIndexMap.delete(type);
                else toRemove.add(i);
            }
        }
    }
    // Anything left in the stack is an unmatched open token
    openTokenIndexMap.forEach((remainingIndex)=>toRemove.add(remainingIndex));
    return toRemove;
}


// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $4cab79ce214481e1$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $4cab79ce214481e1$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const match = token.content.match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123" />
				 * <custom data-type="smartlink" />
				 * <custom data-type="panel_open" data-id="123" />
				 * <custom data-type="panel_close" />
				 */ // Ignored via go/ees005
            // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
            // eslint-disable-next-line require-unicode-regexp
            RegExp('<custom\\s+data-type="(?<dataType>.*?)"\\s*(data-id="(?<dataId>.*?)"\\s*)?\\/>'));
            const dataType = match?.groups?.dataType;
            if (match && dataType && !$4cab79ce214481e1$var$emptyInlineCustomNodes.includes(dataType)) {
                const dataId = match.groups?.dataId;
                if (dataType) {
                    analyticsAttributes.htmlConvertedToNodes++;
                    const customElementToken = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    customElementToken.attrPush([
                        'isCustomBlock',
                        'true'
                    ]);
                    /**
					 * When the custom tag goes through the tokenizer it is transformed into this structure:
					 * paragraph_open
					 * inline
					 * paragraph_close
					 *
					 * so the following section removes the wrapping paragraph tokens
					 */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    analyticsAttributes.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
        const toRemove = (0, $bb6e978431b17277$export$e717b161ec14d433)(state.tokens);
        toRemove.forEach((index)=>{
            const tokenToBeRemoved = state.tokens[index];
            analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] = (analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] || 0) + 1;
        });
        // Remove all indices that have been set in `toRemove`
        if (featureToggles.markdownPlusRemoveUnclosedTokens) state.tokens = state.tokens.filter((_, index)=>!toRemove.has(index));
    });
}



var $a4TK8 = parcelRequire("a4TK8");

function $102908d0f0788df0$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        const start = state.pos;
        const origSrc = state.src;
        let match;
        if (featureToggles.markdownPlusAttributeTest) match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(?:\\s+data-type="(?<dataType>[^"]*)")?(?:\\s+data-id="(?<dataId>[^"]*)")?(?:\\s+data-attrs="(?<dataAttrs>\\{.*?\\})")?\\s*>(?<dataContent>.*?)<\\/custom>'));
        else match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(\\sdata-(type|id)="(?<dataType>.*?)")?(\\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\\/custom>'));
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = match.groups?.dataType;
        const dataId = match.groups?.dataId;
        const dataAttrs = match.groups?.dataAttrs;
        const dataContent = match.groups?.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                case 'placeholder':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
                default:
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (featureToggles.markdownPlusAttributeTest && featureToggles.markdownPlusMentions && !dataId && dataAttrs && customDataType) {
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = dataAttrs;
            }
            if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                analyticsAttributes.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
                if (featureToggles.markdownPlusAttributeTest && dataAttrs) try {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(idMap[dataId].attributes, JSON.parse(dataAttrs))) markdownPlusAttributeStatus.push([
                        customDataType,
                        true
                    ]);
                    else // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
                    if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                } catch (e) {
                    markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                }
            } else {
                analyticsAttributes.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}


const $b85e013b8e2ab0fc$var$decisionItemOpen = 'decisionItem_open';
const $b85e013b8e2ab0fc$var$paragraphOpen = 'paragraph_open';
const $b85e013b8e2ab0fc$var$paragraphClose = 'paragraph_close';
const $b85e013b8e2ab0fc$var$inline = 'inline';
function $b85e013b8e2ab0fc$var$handleParagraphs(acc, token) {
    /**
	 * Traverse up the acc token array, and if a chain of one or more inline tokens are under
	 * a decisionItem_open token, then it is considered to be a paragraph_close token within
	 * a decision item.
	 *
	 * This also works for a paragraph_open token as inlineCount would be zero meaning that
	 * the conditional applies to when decisionItem_open is right above paragraph_open.
	 */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        const type = acc[i]?.type;
        if (!inlineChainEnded) {
            if (type === $b85e013b8e2ab0fc$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $b85e013b8e2ab0fc$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $b85e013b8e2ab0fc$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $b85e013b8e2ab0fc$var$paragraphOpen || type === $b85e013b8e2ab0fc$var$paragraphClose) $b85e013b8e2ab0fc$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}


const $e6de2bb5deb5f668$var$replaceBrWithLineBreak = (text)=>{
    // Matches <br> or <br /> or <br/> with optional trailing space
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/<br\s*\/?>\s?/gi, '\n');
};
const $e6de2bb5deb5f668$var$processInlineChildren = (children)=>{
    for (const child of children)if (child.type === 'text') {
        const newText = $e6de2bb5deb5f668$var$replaceBrWithLineBreak(child.content);
        if (child.content !== newText) child.content = newText;
    }
};
const $e6de2bb5deb5f668$var$brToLineBreak = (state)=>{
    for (const token of state.tokens)if (token.type === 'inline' && token.children) $e6de2bb5deb5f668$var$processInlineChildren(token.children);
};
var $e6de2bb5deb5f668$export$2e2bcd8739ae039 = (md)=>md.core.ruler.after('inline', 'lineBreak', $e6de2bb5deb5f668$var$brToLineBreak);


// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");

// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7715b3c791c155be$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $7715b3c791c155be$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($7715b3c791c155be$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $7715b3c791c155be$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $7715b3c791c155be$export$8acd10161c5f8b07(text) {
    return text.replace(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s]+$/) ? `<${str}>` : str;
    });
}


// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $866d7fb158c265f1$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $866d7fb158c265f1$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($866d7fb158c265f1$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($866d7fb158c265f1$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $81OAa.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $7715b3c791c155be$export$d37783fe63e2f0fe)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $7715b3c791c155be$export$5e652e74655163e5)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $866d7fb158c265f1$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$866d7fb158c265f1$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $866d7fb158c265f1$var$linkify);


// File copied from packages/editor/editor-markdown-transformer/src/media.ts

var $bd943 = parcelRequire("bd943");

function $623b0b26b9c81375$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
    // due to shift+enter
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'paragraph_close'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
                const urlObject = new URL(getUrl(url));
                const params = urlObject.searchParams;
                if (params.toString()) {
                    const pmAttrs = {};
                    for (const [key, value] of params)pmAttrs[key] = value;
                    // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
                    media.pmAttrs = pmAttrs;
                }
            } catch  {}
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $623b0b26b9c81375$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $623b0b26b9c81375$var$createRule());
};


// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73825321bd2619ae$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$73825321bd2619ae$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $73825321bd2619ae$var$newline);






// eslint-disable-next-line require-unicode-regexp
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $3f17de48a6931d92$var$mediaRegex = /(!\[[^\]]*\]\([^)]+\))|(\[!\[[^\]]*\]\([^)]+\)\]\([^)]+\))/gu;
const $3f17de48a6931d92$var$getUrl = (state, str)=>{
    const res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
    if (res.ok) {
        const href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) return href;
    }
    return '';
};
const $3f17de48a6931d92$var$checkPreviousToken = (type, acc)=>{
    return acc.length > 0 && acc[acc.length - 1].type === type;
};
const $3f17de48a6931d92$var$createMediaTokens = (url, state, acc)=>{
    const mediaSingleOpen = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'media_single_open');
    const media = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'media');
    media.attrs = [
        [
            'url',
            $3f17de48a6931d92$var$getUrl(state, url)
        ],
        [
            'type',
            'external'
        ]
    ];
    // This is a hack to get internal media to work
    // to recreate the image correctly we need to apply the pmAttrs from the image
    // We store the pmAttrs in the "fake" image url and apply them to the token
    if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
        const urlObject = new URL($3f17de48a6931d92$var$getUrl(state, url));
        const params = urlObject.searchParams;
        if (params.toString()) {
            const pmAttrs = {};
            for (const [key, value] of params)pmAttrs[key] = value;
            // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            media.pmAttrs = pmAttrs;
        }
    } catch  {}
    const mediaSingleClose = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'media_single_close');
    acc.push(mediaSingleOpen, media, mediaSingleClose);
};
const $3f17de48a6931d92$var$createInlineTokens = (content, state, acc)=>{
    const paragraphOpen = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'paragraph_open');
    const inline = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'inline');
    inline.content = content;
    inline.children = [
        (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'text')
    ];
    const paragraphClose = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, 'paragraph_close');
    acc.push(paragraphOpen, inline, paragraphClose);
};
/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */ const $3f17de48a6931d92$var$findContent = (token)=>{
    let content = [];
    let lastIndex = 0;
    let match;
    $3f17de48a6931d92$var$mediaRegex.lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while((match = $3f17de48a6931d92$var$mediaRegex.exec(token.content)) !== null){
        const matchedString = match[0];
        const matchIndex = match.index;
        if (lastIndex < matchIndex) content.push(token.content.substring(lastIndex, matchIndex));
        content.push(matchedString);
        lastIndex = matchIndex + matchedString.length;
    }
    if (lastIndex < token.content.length) content.push(token.content.substring(lastIndex));
    content = content.filter((item)=>item.length > 0);
    return content;
};
function $3f17de48a6931d92$export$2e2bcd8739ae039(md) {
    md.core.ruler.before('inline', 'media', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'inline' && $3f17de48a6931d92$var$mediaRegex.test(token.content)) {
                // If the previous token is a paragraph_open we want to remove it
                if ($3f17de48a6931d92$var$checkPreviousToken('paragraph_open', acc)) acc.pop();
                const content = $3f17de48a6931d92$var$findContent(token);
                content.forEach((item)=>{
                    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    const doesMatch = /!\[[^\]]*\]\([^)]+\)/u.test(item);
                    if (doesMatch) $3f17de48a6931d92$var$createMediaTokens(item, state, acc);
                    else $3f17de48a6931d92$var$createInlineTokens(item, state, acc);
                });
            // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
            // or paragraph_close
            } else if (type === 'paragraph_close') {
                if (!$3f17de48a6931d92$var$checkPreviousToken('media_single_close', acc) && !$3f17de48a6931d92$var$checkPreviousToken('paragraph_close', acc)) acc.push(token);
            } else acc.push(token);
            return acc;
        }, []);
    });
}


// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $811470bd95061a4c$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$811470bd95061a4c$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $811470bd95061a4c$var$paragraph);



const $11bccb76849cfb3f$var$bulletListOpen = 'bullet_list_open';
const $11bccb76849cfb3f$var$bulletListClose = 'bullet_list_close';
const $11bccb76849cfb3f$var$listItemOpen = 'list_item_open';
const $11bccb76849cfb3f$var$listItemClose = 'list_item_close';
const $11bccb76849cfb3f$var$taskListOpen = 'task_list_open';
const $11bccb76849cfb3f$var$taskListClose = 'task_list_close';
const $11bccb76849cfb3f$var$taskItemOpen = 'task_item_open';
const $11bccb76849cfb3f$var$taskItemClose = 'task_item_close';
const $11bccb76849cfb3f$var$paragraphOpen = 'paragraph_open';
const $11bccb76849cfb3f$var$paragraphClose = 'paragraph_close';
function $11bccb76849cfb3f$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    return acc[acc.length + indexOffset]?.type === type;
}
function $11bccb76849cfb3f$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListOpen, $11bccb76849cfb3f$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListOpen));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenListItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$listItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$bulletListClose));
            acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListOpen));
        }
        newTaskItemOpen.meta = $11bccb76849cfb3f$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskListClose));
            acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $11bccb76849cfb3f$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline') && $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $6d1436b1813e587d$export$c255480b061bd6aa)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc, -2).level));
    else if (!$11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose)) acc.push(token);
}
function $11bccb76849cfb3f$var$handleInline(token, acc) {
    if (token.children?.[0]) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    token.children[0].content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.children[0].content);
    token.content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.content);
    token.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $11bccb76849cfb3f$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen) || $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $11bccb76849cfb3f$var$taskItemOpen;
}
function $11bccb76849cfb3f$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $11bccb76849cfb3f$var$removeTodoMarkdown(content) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regex = /(\[x\]\s)|(\[\s\]\s)/;
    return content.replace(regex, '');
}
function $11bccb76849cfb3f$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $11bccb76849cfb3f$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $11bccb76849cfb3f$var$bulletListOpen) $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $11bccb76849cfb3f$var$bulletListClose) $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemOpen) $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index);
            else if ($11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc)) $11bccb76849cfb3f$var$handleInline(token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemClose) $11bccb76849cfb3f$var$handleListItemClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$paragraphOpen || type === $11bccb76849cfb3f$var$paragraphClose) $11bccb76849cfb3f$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}



function $ce78ef6bb9d33c7d$var$getFragmentBackingArray(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $ce78ef6bb9d33c7d$var$mapFragment(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($ce78ef6bb9d33c7d$var$mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $5SAOw.Fragment)) children.push(...$ce78ef6bb9d33c7d$var$getFragmentBackingArray(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $5SAOw.Fragment).fromArray(children);
}
function $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus } = featureToggles;
    const tokenizer = new (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $fe15ff31308e86c4$export$b535e2638dcce02)[key])if (schema[key][idx]) tokenizer.enable((0, $fe15ff31308e86c4$export$b535e2638dcce02)[key][idx]);
    });
    const analyticsAttributes = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {}
    };
    // Remove once markdownPlusAttributeTest is removed
    const markdownPlusAttributeStatus = [];
    if (markdownPlus) {
        tokenizer.use((0, $4cab79ce214481e1$export$2e2bcd8739ae039), idMap, featureToggles, analyticsAttributes);
        tokenizer.use((0, $b85e013b8e2ab0fc$export$2e2bcd8739ae039), idMap);
        tokenizer.use((0, $102908d0f0788df0$export$2e2bcd8739ae039), idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus);
    }
    tokenizer.use((0, $e92fa7dc1daa52ee$export$2e2bcd8739ae039), idMap);
    tokenizer.use((0, $811470bd95061a4c$export$2e2bcd8739ae039));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $866d7fb158c265f1$export$2e2bcd8739ae039));
    tokenizer.use((0, $73825321bd2619ae$export$2e2bcd8739ae039));
    tokenizer.use((0, $e6de2bb5deb5f668$export$2e2bcd8739ae039));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $csam1.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        if (featureToggles.markdownPlusUseNextMediaPlugin) tokenizer.use((0, $3f17de48a6931d92$export$2e2bcd8739ae039));
        else tokenizer.use((0, $623b0b26b9c81375$export$c8dcbd316b71f8cf));
        if (markdownPlus && featureToggles.markdownPlusAddComplexNodes) tokenizer.use((0, $0773845a48a88423$export$2e2bcd8739ae039));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $11bccb76849cfb3f$export$2e2bcd8739ae039));
    const markdownParser = new (0, $42JDa.MarkdownParser)(schema, tokenizer, (0, $fe15ff31308e86c4$export$a9d25ff08f358d72)(schema, (0, $fe15ff31308e86c4$export$8f853a1c35ed8bbe)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {},
        markdownPlusAttributeStatus: [],
        pmFragment: (0, $5SAOw.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    const prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $7715b3c791c155be$export$8acd10161c5f8b07)(markdown));
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    const mappedContent = $ce78ef6bb9d33c7d$var$mapFragment(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') {
            const replacedAttrs = Object.fromEntries(Object.entries(node.attrs).map(([key, value])=>{
                // If value is the literal string 'null', convert it to JS null
                return [
                    key,
                    value === 'null' ? null : value
                ];
            }));
            return schema.nodes.media.createChecked({
                ...replacedAttrs,
                // Adding this attribute results in the media node being rendered
                // initially using the external url, but then triggering an upload
                // of the external url as an atlassian artifact, and this media
                // will then be replaced to use the atlassian artifact.
                //
                // This is done in the media nodeview by checking the attributes
                // when rendering.
                __external: replacedAttrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
        }
        return node;
    });
    return {
        ...analyticsAttributes,
        markdownPlusAttributeStatus: markdownPlusAttributeStatus,
        pmFragment: mappedContent
    };
}
function $ce78ef6bb9d33c7d$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}
module.exports["convertMarkdownToProsemirror"] = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123;
module.exports["backendConvertMarkdownToProsemirrorNode"] = $ce78ef6bb9d33c7d$export$e661a057c2263d64;

});

parcelRegister("9J8UT", function(module, exports) {
/* AIChatIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8aef4f4f02d5b2fe$var$styles = {
    container: "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1crf _1bsb1crf"
};
const $8aef4f4f02d5b2fe$var$ROVO_SVG_PATH = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L10.7381 2.50115C11.1589 2.7437 11.4193 3.1937 11.4193 3.67848V8.31707C11.4193 8.80377 11.1604 9.25178 10.7385 9.4942L7.71671 11.2376C7.72332 11.219 7.72963 11.2003 7.73565 11.1815C7.79172 11.0077 7.82146 10.8241 7.82146 10.6363V5.99777C7.82146 5.36053 7.4823 4.7729 6.92908 4.45501L6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224Z" fill="#FCA700"/>
		<path d="M4.35709 0.762451L1.33533 2.50585C0.91337 2.74828 0.654541 3.19629 0.654541 3.68299V8.32158C0.654541 8.80636 0.914895 9.25633 1.33561 9.49887L2.05206 9.91223L5.35553 11.8182C5.76872 12.0563 6.27717 12.0606 6.69373 11.8308C6.70128 11.825 6.7093 11.8196 6.71781 11.8147C7.01463 11.6435 7.2317 11.3691 7.33376 11.0521C7.3753 10.9211 7.39725 10.7826 7.39725 10.6409V8.84408L5.64872 7.83569L5.14485 7.54513C4.59174 7.22722 4.25234 6.63946 4.25234 6.00228V1.3637C4.25234 1.17625 4.28199 0.992849 4.33793 0.81927C4.344 0.800208 4.35039 0.781265 4.35709 0.762451Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64872 7.83569L2.05206 9.91223L1.33561 9.49887C0.914895 9.25633 0.654541 8.80636 0.654541 8.32158V3.68299C0.654541 3.19629 0.91337 2.74828 1.33533 2.50585L4.35709 0.762451C4.35039 0.781265 4.344 0.800208 4.33793 0.81927C4.28199 0.992849 4.25234 1.17625 4.25234 1.3637V6.00228C4.25234 6.63946 4.59174 7.22722 5.14485 7.54513L5.64872 7.83569Z" fill="#1868DB"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L6.37094 4.13313Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7381 2.5012L9.9676 2.05664L6.37094 4.13318L6.92907 4.45507C7.48229 4.77296 7.82146 5.36059 7.82146 5.99783V10.6364C7.82146 10.8241 7.79172 11.0078 7.73565 11.1816C7.72963 11.2004 7.72332 11.2191 7.71671 11.2377L10.7385 9.49426C11.1604 9.25184 11.4193 8.80382 11.4193 8.31712V3.67853C11.4193 3.19376 11.1589 2.74376 10.7381 2.5012Z" fill="#AF59E0"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64873 7.83569L2.05206 9.91224L5.35553 11.8182C5.76873 12.0564 6.27718 12.0606 6.69373 11.8308C6.70128 11.825 6.70931 11.8196 6.71782 11.8147C7.01463 11.6436 7.2317 11.3691 7.33377 11.0521C7.37531 10.9211 7.39726 10.7826 7.39726 10.6409V8.84409L5.64873 7.83569Z" fill="#6A9A23"/>
	</svg>`;
const $8aef4f4f02d5b2fe$var$RovoLogoSVG = ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        role: "img",
        "aria-label": label,
        "data-testid": testId,
        dangerouslySetInnerHTML: {
            __html: $8aef4f4f02d5b2fe$var$ROVO_SVG_PATH
        },
        className: (0, $gMc0m.default)([
            $8aef4f4f02d5b2fe$var$styles.container
        ])
    });
const $8aef4f4f02d5b2fe$export$4476d508de061a72 = ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)($8aef4f4f02d5b2fe$var$RovoLogoSVG, {
        label: label,
        testId: testId
    });
module.exports["AIChatIcon"] = $8aef4f4f02d5b2fe$export$4476d508de061a72;

});

parcelRegister("abUsF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $9J8UT = parcelRequire("9J8UT");

var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


var $c6GJD = parcelRequire("c6GJD");


var $fzqvY = parcelRequire("fzqvY");

var $fb3kw = parcelRequire("fb3kw");


var $ghftu = parcelRequire("ghftu");


var $4fdTR = parcelRequire("4fdTR");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $lBFuf = parcelRequire("lBFuf");


var $i25hX = parcelRequire("i25hX");


var $4noo5 = parcelRequire("4noo5");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $kIvLT = parcelRequire("kIvLT");


var $ygGKm = parcelRequire("ygGKm");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0d32633bd323405d$var$store = (0, $1P1Tu.createStore)({
    name: 'RovoChatHighlightActionsStore',
    initialState: {
        isMoreOptionsPopupOpen: false
    },
    actions: {
        setIsMoreOptionsPopupOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isMoreOptionsPopupOpen: isOpen
                });
            }
    }
});
const $0d32633bd323405d$export$6c9cf98a64763bb1 = (0, $9zUhf.createHook)($0d32633bd323405d$var$store);
const $0d32633bd323405d$export$f1e33ed2d48967b4 = (0, $9zUhf.createActionsHook)($0d32633bd323405d$var$store);



var $gjr93 = parcelRequire("gjr93");


var $cgtv4 = parcelRequire("cgtv4");

var $1ee4456065df4341$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    rovoChatAskInChatButtonText: {
        id: "highlight-actions.rovo-chat.ask-in-chat-button-text",
        defaultMessage: "Ask in Chat"
    },
    rovoChatAskRovoButtonText: {
        id: "highlight-actions.rovo-chat.ask-rovo-button-text",
        defaultMessage: "Ask Rovo"
    },
    rovoChatOpenChatTooltip: {
        id: "highlight-actions.rovo-chat-open-chat.tooltip",
        defaultMessage: "Open Chat"
    },
    rovoChatMoreOptionsTooltip: {
        id: "highlight-actions.rovo-chat-more-options.tooltip",
        defaultMessage: "Chat recommendations"
    },
    rovoChatSummarizeOptionText: {
        id: "highlight-actions.rovo-chat-summarize-option.text",
        defaultMessage: "Summarize"
    },
    rovoChatExplainOptionText: {
        id: "highlight-actions.rovo-chat-explain-option.text",
        defaultMessage: "Explain"
    },
    rovoChatFindResourcesOptionText: {
        id: "highlight-actions.rovo-chat-find-resources-option.text",
        defaultMessage: "Find resources"
    },
    rovoChatGiveFeedbackOptionText: {
        id: "highlight-actions.rovo-chat-give-feedback-option.text",
        defaultMessage: "Give feedback"
    },
    rovoChatGiveExamplesOptionText: {
        id: "highlight-actions.rovo-chat-give-examples-option.text",
        defaultMessage: "Give examples"
    },
    rovoChatSummarizePrompt: {
        id: "highlight-actions.rovo-chat-summarize-prompt",
        defaultMessage: "Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph."
    },
    rovoChatExplainPrompt: {
        id: "highlight-actions.rovo-chat-explain-prompt",
        defaultMessage: "Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing."
    },
    rovoChatFindResourcesPrompt: {
        id: "highlight-actions.rovo-chat-find-resources-prompt",
        defaultMessage: "Find resources within organizational knowledge only that supports the statements made."
    },
    rovoChatGiveFeedbackPrompt: {
        id: "highlight-actions.rovo-chat-give-feedback-prompt",
        defaultMessage: "Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change."
    },
    rovoChatGiveExamplesPrompt: {
        id: "highlight-actions.rovo-chat-give-examples-prompt",
        defaultMessage: "Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more."
    },
    rovoChatCustomPromptPlaceholder: {
        id: "highlight-actions.rovo-chat-custom-prompt.placeholder",
        defaultMessage: "Ask AI about this"
    },
    rovoChatCustomPromptSubmitButtonText: {
        id: "highlight-actions.rovo-chat-custom-prompt-submit-button.text",
        defaultMessage: "Send"
    }
});


const $157c507ad23459f7$var$styles = {
    popupContainer: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    formWrapper: "_1pfhx0bf",
    sendIconWrapper: "_y4tiutpp",
    rovoChatMoreOptionsButtonContainer: "_ahbqx0bf",
    rovoChatOpenChatIcon: "_bozgv77o"
};
const $157c507ad23459f7$export$1ccbc9113b239d47 = ({ selectedContent: selectedContent, product: product, onClickChat: onClickChat, onClickPromptOverride: onClickPromptOverride, onSubmitCustomPromptOverride: onSubmitCustomPromptOverride })=>{
    (0, $fBMbo.di)((0, $c6GJD.default), (0, $0d32633bd323405d$export$6c9cf98a64763bb1));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { setIsMoreOptionsPopupOpen: setIsMoreOptionsPopupOpen } = (0, $0d32633bd323405d$export$f1e33ed2d48967b4)();
    const [{ isMoreOptionsPopupOpen: isMoreOptionsPopupOpen }] = (0, $0d32633bd323405d$export$6c9cf98a64763bb1)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $gjr93.useHighlightActionsEditorPlaceholder)();
    (0, $42omo.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'contextualMenuItem',
            actionSubjectId: 'rovoChatHighlightActions',
            attributes: {
                product: product
            }
        });
    }, [
        sendAnalyticsEvent,
        product
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsMoreOptionsPopupOpen(false);
    }, [
        setIsMoreOptionsPopupOpen
    ]);
    const handleClickChat = (0, $42omo.useCallback)(async ()=>{
        onClickChat();
        insertHighlightActionsEditorPlaceholder(selectedContent);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuRovoChatButton',
            attributes: {
                product: product
            }
        });
    }, [
        onClickChat,
        insertHighlightActionsEditorPlaceholder,
        selectedContent,
        sendAnalyticsEvent,
        product
    ]);
    const handlePromptSubmit = (0, $42omo.useCallback)((values, form)=>{
        const formattedPrompt = (0, $ygGKm.appendADFContent)(selectedContent, values.prompt);
        if (onSubmitCustomPromptOverride) {
            onSubmitCustomPromptOverride(formattedPrompt);
            form.reset();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
                attributes: {
                    product: product
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: `${product}-context-menu`,
            data: {
                name: values.prompt.substring(0, 30),
                dialogues: [],
                prompt: formattedPrompt
            }
        });
        form.reset();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
            attributes: {
                product: product
            }
        });
    }, [
        publish,
        sendAnalyticsEvent,
        product,
        onSubmitCustomPromptOverride,
        selectedContent
    ]);
    const rovoChatPromptOptions = [
        {
            id: 'context-menu-rovo-chat-summarize-option',
            actionType: 'summarize',
            prompt: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatSummarizePrompt),
            optionText: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatSummarizeOptionText)
        },
        {
            id: 'context-menu-rovo-chat-explain-option',
            actionType: 'explain',
            prompt: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatExplainPrompt),
            optionText: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatExplainOptionText)
        },
        {
            id: 'context-menu-rovo-chat-find-resources-option',
            actionType: 'find-resources',
            prompt: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatFindResourcesPrompt),
            optionText: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatFindResourcesOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-feedback-option',
            actionType: 'give-feedback',
            prompt: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatGiveFeedbackPrompt),
            optionText: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatGiveFeedbackOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-examples-option',
            actionType: 'give-examples',
            prompt: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatGiveExamplesPrompt),
            optionText: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatGiveExamplesOptionText)
        }
    ];
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            testId: "context-menu-rovo-chat-popup",
            xcss: $157c507ad23459f7$var$styles.popupContainer,
            space: "space.150",
            children: [
                rovoChatPromptOptions.map((option)=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
                        testId: option.id,
                        onClick: ()=>{
                            const formattedPrompt = (0, $ygGKm.appendADFContent)(selectedContent, option.prompt);
                            if (onClickPromptOverride) {
                                onClickPromptOverride(formattedPrompt);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                                    attributes: {
                                        actionType: option.actionType,
                                        product: product
                                    }
                                });
                                return;
                            }
                            publish({
                                type: 'chat-new',
                                source: `${product}-context-menu`,
                                data: {
                                    name: option.prompt.substring(0, 30),
                                    dialogues: [],
                                    prompt: formattedPrompt
                                }
                            });
                            sendAnalyticsEvent({
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                                attributes: {
                                    actionType: option.actionType,
                                    product: product
                                }
                            });
                        },
                        children: option.optionText
                    }, option.id);
                }),
                (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handlePromptSubmit,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                        name: "prompt",
                        children: ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default // this prevents the highlight actions popup from closing when clicking on the input
                            ), {
                                onClick: (e)=>e.stopPropagation(),
                                ...fieldPropsRest,
                                testId: "context-menu-rovo-chat-custom-prompt",
                                id: "context-menu-rovo-chat-custom-prompt",
                                autoComplete: "off",
                                elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $157c507ad23459f7$var$styles.sendIconWrapper,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        testId: "context-menu-rovo-chat-custom-prompt-submit",
                                        isDisabled: !dirty || !value,
                                        label: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatCustomPromptSubmitButtonText),
                                        type: "submit",
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                        spacing: "compact"
                                    })
                                }),
                                placeholder: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatCustomPromptPlaceholder),
                                "aria-label": formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatCustomPromptPlaceholder)
                            })
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handlePromptSubmit,
                    children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $157c507ad23459f7$var$styles.formWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("form", {
                                ...formProps,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    name: "prompt",
                                    children: ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default // this prevents the highlight actions popup from closing when clicking on the input
                                        ), {
                                            onClick: (e)=>e.stopPropagation(),
                                            ...fieldPropsRest,
                                            testId: "context-menu-rovo-chat-custom-prompt",
                                            id: "context-menu-rovo-chat-custom-prompt",
                                            autoComplete: "off",
                                            elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $157c507ad23459f7$var$styles.sendIconWrapper,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                    testId: "context-menu-rovo-chat-custom-prompt-submit",
                                                    isDisabled: !dirty || !value,
                                                    label: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatCustomPromptSubmitButtonText),
                                                    type: "submit",
                                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                                    spacing: "compact"
                                                })
                                            }),
                                            placeholder: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatCustomPromptPlaceholder),
                                            "aria-label": formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatCustomPromptPlaceholder)
                                        })
                                })
                            })
                        })
                })
            ]
        });
    };
    const isToolbarAIFCEnabled = (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true);
    if (product === 'confluence' && isToolbarAIFCEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatOpenChatTooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $9J8UT.AIChatIcon), {
                label: ""
            }),
            onClick: handleClickChat,
            testId: "context-menu-rovo-chat-button",
            children: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatAskRovoButtonText)
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatOpenChatTooltip),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "subtle",
                    iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            xcss: $157c507ad23459f7$var$styles.rovoChatOpenChatIcon,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                                size: "xsmall"
                            })
                        }),
                    onClick: handleClickChat,
                    testId: "context-menu-rovo-chat-button",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        weight: "medium",
                        children: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatAskRovoButtonText)
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                placement: "bottom-start",
                isOpen: isMoreOptionsPopupOpen,
                onClose: onClose,
                content: renderPopupContent,
                zIndex: 600,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $157c507ad23459f7$var$styles.rovoChatMoreOptionsButtonContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            ...triggerProps,
                            appearance: "subtle",
                            id: "context-menu-rovo-chat-more-options",
                            testId: "context-menu-rovo-chat-more-options",
                            isTooltipDisabled: false,
                            icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                    ...props,
                                    label: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatMoreOptionsTooltip),
                                    size: "small"
                                }),
                            label: formatMessage((0, $1ee4456065df4341$export$2e2bcd8739ae039).rovoChatMoreOptionsTooltip),
                            onClick: ()=>{
                                setIsMoreOptionsPopupOpen(!isMoreOptionsPopupOpen);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'highlightActionsMenuRovoChatMoreOptionsButton',
                                    attributes: {
                                        product: product
                                    }
                                });
                            }
                        })
                    })
            })
        ]
    });
};
module.exports["RovoChatHighlightActions"] = $157c507ad23459f7$export$1ccbc9113b239d47;

});

parcelRegister("j2DyP", function(module, exports) {
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $3c7c331d93a4dcee$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $3c7c331d93a4dcee$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.cause.message)));
module.exports["isClientFetchError"] = $3c7c331d93a4dcee$export$2e7adc44463c3f4f;

});

parcelRegister("bd943", function(module, exports) {
const $3b4ff3e4ad90548c$export$53fd140c96bc558 = 'https://media.staging.atl-paas.net';
module.exports["MEDIA_BASE_URL_STAGING"] = $3b4ff3e4ad90548c$export$53fd140c96bc558;

});

parcelRegister("ygGKm", function(module, exports) {
const $604298656c254432$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $604298656c254432$export$f00236a854eaa848;

});


//# sourceMappingURL=mention.b17b2585.js.map
